import {
  CaddySelectionCriteria,
  ItemizedBill,
  BuggyDayDetails,
  CaddyDayDetails,
  ClubRating,
  RatingItem,
  BookingStatistics,
  CourseUtilizationStatistics,
  CaddieBuggyAssignmentStatistics,
  BookingOfflinePayment,
  CaddyAssignment,
  TeeTimeClubVoucher,
  ClubData,
  CancelBookingSpecification,
  ClubMembership,
  ClubHelpItem,
  LowestAverageGrossLeaderboard,
  PlayerLowestAverageGross,
  LeagueScorecards,
  PlayerRoundScores,
  EclecticPlayerRound,
  LeagueLeaderboard,
  PagedData,
  ClubCaddieSchedule,
  Unavailability,
  BookingCount,
  PaymentMethod,
  PlayerClubWalletBalance,
  PlayerClubWalletTransactionPage,
  PlayerClubWalletTopupPage,
  UserAuthentication,
  TeeTimePrice,
  TeeTimePriceComponent,
  PlayerClubWalletBalancePage,
  ClubDataLite,
  ClubDataLitePage,
  ClubOutletPage,
  ClubOutlet,
  PlayerClubAccount,
  ClubMembershipType,
  ClubMembershipOption,
  AddressData,
  PlayerClubAccountStatement,
  PlayerClubAccountStatementPage,
  ClubMembershipPage,
  PlayerDataPage,
  DiscountCompanyPage,
  PlayerInsurance,
  Bill,
  PartnerProgramMembershipApplicationPage,
  PlayerDiscountProgram,
  PlayerClubAccountPage,
  PlayerDiscountProgramPage,
  TeeTimePricingPlan,
  TeeTimeSlotDisplayPage,
  BuggyType,
  ClubPaymentInstancePage,
  CompetitionRound,
  PaymentTrxnType,
  RefundTrxnType,
  TrxnTypePriceComponentMap,
  TransactionType,
  TransactionGroup,
  BookingAgentClubSetting,
  DiscountCompany,
  PlayerClubAccountTransactionPage,
  UserAddress,
  PlayerClubStat,
  CompetitionRoundCourseRatings,
  LeaderBoard,
  LeaderBoardPlayer,
  CompetitionData,
  CompetitionScorecards,
  PlayerScorecard,
  FlightData,
  PlayerInFlightData,
  News,
  NewsPage,
  OfferAndAdvertisement,
  OffersAndAdvertisementPage,
  TeeTimeClubVoucherSeries,
  VoucherSeriesPage,
  ClubDataPage,
  TeeTimeClubVoucherPage,
  ClubFacilityBooking,
  ClubFacilityBookingPage,
  ClubMembershipExtended,
  BookableFacilitySearchResult,
  FacilityBookingRequest,
  TeamScores,
  Order,
  OrderPage,
  CompetitionSponsorInfo,
  AdditionalItemCount,
  BookingPax,
  ClubSlotCountsPage,
  ClubSlotCounts,
  TSlotPrice,
  ClubTSlotList,
  ClubCourseData,
  ClubCourseHoleData,
  CompetitionDataPage,
  CompetitionPlayerData,
  CompetitionDataLite,
  CompetitionDataLitePage,
  OrganizerDataPage,
  OrganizerData,
  LeaguePlayerTotal,
  LeagueCompetitionPlayerTotal,
  CompetitionFeeApplicable,
  CompetitionMatch,
  CompetitionMatchPlayLeaderboard,
  CompetitionTeamPlayerData,
  CompetitionMatchPlayLeaderboardTeam,
  CompetitionMatchProgressiveScore,
} from './../../data/mygolf.data';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { RemoteHttpService } from '../../remote-http';
import * as global from '../../globals';
import { ContentType, RemoteRequest } from '../../remote-request';
import { Custom_RequestMethod, removeEmptyKeys } from '../common-service';
import { ClubList, CourseHoleInfo, CourseInfo } from '../../data/club-course';
import { JsonService } from '../../json-util';
import { Observable, observable, pipe, throwError } from 'rxjs';
import { isPresent } from '../common-service';
import { SearchCriteria } from '../../data/search-criteria';
import {
  TeeTimeFlight,
  BuggyData,
  CaddyData,
  CaddySchedule,
  BuggySchedule,
  TeeTimeSlot,
  TeeTimeSlotBookingRequest,
  TeeTimeSlotDisplay,
  ClubTeeTimeSlots,
  TeeTimeBooking,
  TeeTimeBookingPlayer,
  TeeTimeBookingOptions,
  PlayerData,
  BuggyCaddiePreference,
  FutureBookingStatistics,
  CaddieBuggyStatistics,
  HandicapSystem,
} from '../../data/mygolf.data';
import { ClubInfo } from '../../data/mygolf.data';
import * as moment from 'moment';
import { PlayerInfo } from '../../data/player-data';
import { FiletransferService } from '../filetransfer-service/filetransfer-service';
import { UploadResult } from '../../data/fileupload-result';
import { ContactUsItem, GroupItem, HelpURLs } from 'src/app/pages/contact-us/contact-us.page';
import { from } from 'rxjs';
import { CommonProvider } from 'src/app/pages/commonServices/common';
import { Platform } from '@ionic/angular';
import { ServerResult } from 'src/data/server-result';
import * as appProps from 'src/appProperties';
import { OrderService } from '../order-service/order-service';
@Injectable()
export class ClubFlightService {
  constructor(
    public http: RemoteHttpService,
    private ftService: FiletransferService,
    public requestMethod: Custom_RequestMethod,
    private commonProvider: CommonProvider,
    private platform: Platform,
    private orderService: OrderService
  ) {}

  /**
   * Gets the information about a single club
   * @param clubId The ID of the club
   */
  public getClubInfo(clubId: number): Observable<ClubInfo> {
    let request = new RemoteRequest(
      global.ServerUrls.getClub,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
        fullDetails: true,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubInfo: ClubInfo = resp;
          if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = 'document/img/default_club.png';
          JsonService.deriveFullUrl(clubInfo, 'clubImage');
          return clubInfo;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Get the courses for a given club
   * @param clubId The ID of the club
   * @returns {Observable<R>}
   */
  public getClubCourses(clubId: number): Observable<Array<CourseInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.getClubCourses,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let courses: Array<CourseInfo> = resp;
          courses.forEach((c: CourseInfo) => {
            JsonService.deriveFullUrl(c, 'photoUrl');
            c.holes.forEach((h: CourseHoleInfo) => {
              JsonService.deriveFullUrl(h, 'holeImage');
            });
          });
          return courses;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Gets the nearby club within a certain distance
   * @param maxDistance The maximum distance from the club to current location.
   * The current location details are automatically addedd
   * @returns {Observable<R>} Returns the Observable with next method returning
   * array of ClubInfo objects
   */
  public getNearbyClubs(maxDistance: number = 10): Observable<Array<ClubInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.getClubsNearby,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        maxDistance: maxDistance,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubInfos: Array<ClubInfo> = resp;
          clubInfos.forEach((c: ClubInfo) => {
            if (!isPresent(c.clubImage)) c.clubImage = 'document/img/default_club.png';
            JsonService.deriveFullUrl(c, 'clubImage');
          });
          return clubInfos;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Gets the recent clubs played. The ID of the player is automatically inserted
   * @param maxClubs The maximum number of recent clubs to return
   * @returns {Observable<R>}
   */
  public getRecentClubs(maxClubs: number = 10, type?: string): Observable<Array<ClubInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.getRecentClubs,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        maxItems: maxClubs,
        type: type,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubInfos: Array<ClubInfo> = resp;
          clubInfos.forEach((c: ClubInfo) => {
            if (!isPresent(c.clubImage)) c.clubImage = 'document/img/default_club.png';

            JsonService.deriveFullUrl(c, 'clubImage');
          });

          return clubInfos;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Search clubs
   * @param searchText The search text filter. The search is applied on clubName, tag, address,
   * city, state
   * @param activeOnly Only clubs with status "Active" are considered.
   * @param pageNumber The search happens in paged manner. this parameter specifies which page is
   * requested
   * @param countryId The optional country id. Only clubs from this country are returned. Clubs
   * without country are ignored
   * @returns {Observable<R>}
   */
  public searchClubs(
    searchText: string,
    activeOnly: boolean,
    pageNumber: number,
    countryId?: string,
    pageSize?: number,
    newAPI: boolean = false
  ): Observable<ClubList> {
    let _url = global.ServerUrls.searchClubs;
    if (newAPI) _url = global.ServerUrls.getClubList;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        searchText: searchText,
        activeOnly: activeOnly,
        pageNumber: pageNumber,
        countryId: countryId,
        pageSize: pageSize,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('search clubs', resp);
          let clubList: ClubList = resp;
          if (clubList && clubList?.clubs)
            clubList.clubs.forEach((c: any) => {
              if (!isPresent(c.clubImage)) c.clubImage = 'document/img/default_club.png';

              JsonService.deriveFullUrl(c, 'clubImage');
            });
          return clubList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Search clubs
   * @param searchText The search text filter. The search is applied on clubName, tag, address,
   * city, state
   * @param activeOnly Only clubs with status "Active" are considered.
   * @param pageNumber The search happens in paged manner. this parameter specifies which page is
   * requested
   * @param countryId The optional country id. Only clubs from this country are returned. Clubs
   * without country are ignored
   * @returns {Observable<R>}
   */
  public searchClubsNew(
    searchText: string,
    activeOnly: boolean,
    pageNumber: number,
    countryId?: string,
    pageSize?: number,
    clubType: string = 'B'
  ): Observable<ClubDataPage> {
    let _url = global.ServerUrls.getClubList;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        searchText: searchText,
        activeOnly: activeOnly,
        pageNo: pageNumber,
        countryId: countryId,
        pageSize: pageSize,
        clubType: clubType,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('search clubs', resp);
          let clubDataPage: ClubDataPage = resp;
          if (clubDataPage && clubDataPage?.items)
            clubDataPage.items.forEach((c: any) => {
              if (!isPresent(c.clubImage)) c.clubImage = 'document/img/default_club.png';

              JsonService.deriveFullUrl(c, 'clubImage');
            });
          return clubDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getMasterFlightList() {
    let request = new RemoteRequest('assets/teeTimeFlight.json', this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let flightList: any = resp;
          flightList.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
            });
            if (tb.flight) tb.bookingStatus = 'PaymentFull';
          });
          return flightList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingFlightList(
    clubId: number,
    forDate: string,
    registeredOnly: boolean = false,
    includeCancelled: boolean = false
  ) {
    let _params =
      '?clubId=' +
      clubId +
      '&forDate=' +
      forDate +
      '&registeredOnly=' +
      registeredOnly +
      '&includeCancelled=' +
      includeCancelled;
    let request = new RemoteRequest(
      global.ServerUrls.getTeeTimeBookingList + _params,
      this.requestMethod.get
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let flightList: Array<TeeTimeBooking> = resp;
          flightList.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
            JsonService.deriveFullUrl(tb.buggiesAssigned, 'buggyImage');
            JsonService.deriveFullUrl(tb.buggiesAssigned, 'buggyType.pricingComponent.iconUrl');
          });
          return {
            resp,
            flightList,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingFlightDetail() {
    let request = new RemoteRequest('assets/flightDetail.json', this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let flightDetail: TeeTimeFlight = resp;
          return flightDetail;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getBuggyList(clubId: number) {
    let request = new RemoteRequest(
      global.ServerUrls.getBuggyList,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let buggyList: Array<BuggyData> = resp;
          buggyList.forEach((buggy: BuggyData) => {
            JsonService.deriveFullUrl(buggy, 'buggyImage');
          });
          return buggyList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getCaddyList(clubId: number) {
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyList,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyList: Array<CaddyData> = resp;
          caddyList.forEach((caddy: CaddyData) => {
            JsonService.deriveFullUrl(caddy, 'caddyImage');
            JsonService.deriveFullUrl(caddy.nationality, 'flagUrl');
          });
          return caddyList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAvailableCaddiesBooking(bookingId: number) {
    let _bookingId;
    if (bookingId) _bookingId = bookingId;
    let request = new RemoteRequest(
      global.ServerUrls.getAvailableCaddieBooking + '/' + _bookingId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyList: Array<CaddyData> = resp;
          caddyList.forEach((caddy: CaddyData) => {
            JsonService.deriveFulImageURL(caddy, 'caddyImage');
            JsonService.deriveFulImageURL(caddy.nationality, 'flagUrl');
          });
          return caddyList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAvailableCaddies(clubId: number, availableOn: string) {
    let request = new RemoteRequest(
      global.ServerUrls.getAvailableCaddies,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
        availableOn: availableOn,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyList: Array<CaddyData> = resp;
          caddyList.forEach((caddy: CaddyData) => {
            JsonService.deriveFullUrl(caddy, 'caddyImage');
            JsonService.deriveFullUrl(caddy.nationality, 'flagUrl');
          });
          return caddyList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAvailableBuggies(clubId: number, availableOn: string, buggyType: string) {
    let request = new RemoteRequest(
      global.ServerUrls.getAvailableBuggies,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
        availableOn: availableOn,
        buggyType: buggyType,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let buggyList: Array<BuggyData> = resp;
          buggyList.forEach((buggy: BuggyData) => {
            JsonService.deriveFullUrl(buggy, 'buggyImage');
          });

          return buggyList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddySchedule(caddyId: number, fromDate: string, toDate?: string) {
    let request = new RemoteRequest(
      global.ServerUrls.getCaddySchedule,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        caddyId: caddyId,
        fromDate: fromDate,
        toDate: toDate,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddySchedule: CaddySchedule = resp;
          return caddySchedule;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBuggySchedule(buggyId: number, fromDate: string, toDate?: string) {
    let request = new RemoteRequest(
      global.ServerUrls.getBuggySchedule,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        buggyId: buggyId,
        fromDate: fromDate,
        toDate: toDate,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let getBuggySchedule: BuggySchedule = resp;
          return getBuggySchedule;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getTeeTimeSlot(
    forDate: string,
    isClub?: boolean,
    clubCourseId?: number,
    fromTime?: string,
    toTime?: string
  ) {
    let _clubCourseId = clubCourseId;
    let request = new RemoteRequest(
      global.ServerUrls.getTeeTimeSlot,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: isClub ? _clubCourseId : '',
        courseId: isClub ? '' : _clubCourseId,
        forDate: forDate,
        fromTime: fromTime,
        toTime: toTime,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeSlotDisplay: Array<TeeTimeSlotDisplay> = resp;
          teeTimeSlotDisplay.forEach(c => {
            JsonService.deriveFullUrl(c.slot.startCourse, 'courseImage');
            JsonService.deriveFullUrl(c.slot.startCourse, 'courseThumbnail');
          });
          return teeTimeSlotDisplay;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getTeeTimeSlotNearbyClubs(
    forDate: string,
    maxDistance: number,
    fromTime?: string,
    toTime?: string
  ) {
    let hdrs = {};
    let request = new RemoteRequest(
      global.ServerUrls.getTeeTimeSlotNearbyClubs,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        forDate: forDate,
        fromTime: fromTime,
        toTime: toTime,
        maxDistance: maxDistance,
      },
      hdrs
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeSlot: Array<any> = resp;
          teeTimeSlot.forEach(c => {
            JsonService.deriveFullUrl(c.club, 'clubImage');
            JsonService.deriveFullUrl(c.club, 'clubThumbnail');
            JsonService.deriveFullUrl(c.club, 'clubLogo');
          });
          return teeTimeSlot;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getTeeTimeSlotFavClubs(forDate: string, fromTime?: string, toTime?: string) {
    let request = new RemoteRequest(
      global.ServerUrls.getTeeTimeSlotFavClubs,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        forDate: forDate,
        fromTime: fromTime,
        toTime: toTime,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeSlot: Array<ClubTeeTimeSlots> = resp;
          teeTimeSlot.forEach(c => {
            JsonService.deriveFullUrl(c.club, 'clubImage');
            JsonService.deriveFullUrl(c.club, 'clubThumbnail');
            JsonService.deriveFullUrl(c.club, 'clubLogo');
            c.slots.forEach(s => {
              JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
              JsonService.deriveFullUrl(s.slot.startCourse, 'courseThumbnail');
            });
          });
          return {
            teeTimeSlot: teeTimeSlot,
            resp: resp,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListAllSlots(playerId: number, forDate: string, fromTime?: string, toTime?: string) {
    let request = new RemoteRequest(
      global.ServerUrls.listAllSlots,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        forDate: forDate,
        fromTime: fromTime,
        toTime: toTime,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeSlot: Array<ClubTeeTimeSlots> = resp;
          teeTimeSlot.forEach(c => {
            JsonService.deriveFullUrl(c.club, 'clubImage');
            JsonService.deriveFullUrl(c.club, 'clubThumbnail');
            JsonService.deriveFullUrl(c.club, 'clubLogo');
            c.slots.forEach(s => {
              JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
              JsonService.deriveFullUrl(s.slot.startCourse, 'courseThumbnail');
            });
          });
          return {
            teeTimeSlot: teeTimeSlot,
            resp: resp,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getSearchAllSlots(
    forDate: string,
    fromTime?: string,
    toTime?: string,
    pageSize?: number,
    page?: number,
    partnerId?: string,
    clubId?: Array<string>,
    countryId?: string,
    search?: string,
    location?: string
  ) {
    let request = new RemoteRequest(
      global.ServerUrls.searchAllSlots,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        forDate: forDate,
        fromTime: fromTime,
        toTime: toTime,
        pageSize: pageSize,
        pageNo: page,
        partner: partnerId,
        clubs: clubId,
        country: countryId,
        search: search,
        location: location,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeSlot: any = resp;
          if (teeTimeSlot && teeTimeSlot.totalItems > 0) {
            teeTimeSlot.items.forEach(c => {
              JsonService.deriveFullUrl(c.club, 'clubImage');
              JsonService.deriveFullUrl(c.club, 'clubThumbnail');
              JsonService.deriveFullUrl(c.club, 'clubLogo');
              c.slots.forEach(s => {
                JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
                JsonService.deriveFullUrl(s.slot.startCourse, 'courseThumbnail');
              });
            });
          }
          return {
            teeTimeSlot: teeTimeSlot.items,
            resp: resp,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public bookTeeTimeSlot(
    reqBookSlot?: TeeTimeSlotBookingRequest,
    addBookingPlayer: boolean = true,
    captchaResponse?: string
  ): Observable<any> {
    let _reqBookSlot = reqBookSlot;
    let _addBookingPlayer = '?addBookingPlayer=' + (addBookingPlayer ? 'true' : 'false');
    let headers = {};
    if (captchaResponse && captchaResponse.length > 0)
      headers['captcha-response'] = captchaResponse;
    else headers = null;
    let request = new RemoteRequest(
      global.ServerUrls.bookTeeTimeBookingSlot + _addBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      reqBookSlot,
      headers
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getRecaptcha(key: string) {
    let _getRecaptcha = 'https://www.google.com/recaptcha/api2/reload?k=' + key;
    let request = new RemoteRequest(
      _getRecaptcha,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingByPlayer(
    playerId: number,
    fromDate: string,
    maxBookings: number = 999,
    clubId?: number
  ) {
    let request = new RemoteRequest(
      global.ServerUrls.getBookingByPlayer,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        playerId: playerId,
        fromDate: fromDate,
        maxBookings: maxBookings,
        clubId: clubId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingByPlayerList: Array<TeeTimeBooking> = resp;
          bookingByPlayerList.forEach((teeTime: TeeTimeBooking) => {
            teeTime.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(players.player, 'image');
              JsonService.deriveFullUrl(players.player, 'profile');
            });
            JsonService.deriveFullUrl(teeTime.clubData, 'clubImage');
            JsonService.deriveFullUrl(teeTime.clubData, 'clubLogo');
            JsonService.deriveFullUrl(teeTime.clubData, 'clubThumbnail');
          });
          return bookingByPlayerList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingForPlayer(
    playerId: number,
    fromDate: string,
    maxBookings: number = 999,
    clubId?: number
  ) {
    let request = new RemoteRequest(
      global.ServerUrls.getBookingForPlayer,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        playerId: playerId,
        fromDate: fromDate,
        maxBookings: maxBookings,
        clubId: clubId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingByPlayerList: Array<TeeTimeBooking> = resp;
          bookingByPlayerList.forEach((teeTime: TeeTimeBooking) => {
            teeTime.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(players.player, 'image');
              JsonService.deriveFullUrl(players.player, 'profile');
            });
            JsonService.deriveFullUrl(teeTime.clubData, 'clubImage');
            JsonService.deriveFullUrl(teeTime.clubData, 'clubLogo');
            JsonService.deriveFullUrl(teeTime.clubData, 'clubThumbnail');
          });
          return bookingByPlayerList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingById(bookingId: number) {
    let request = new RemoteRequest(
      global.ServerUrls.getBookingById + '/' + bookingId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingByPlayer: TeeTimeBooking = resp;
          JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubImage');
          JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubLogo');
          JsonService.deriveFullUrl(bookingByPlayer.clubData, 'clubThumbnail');
          bookingByPlayer.bookingPlayers.forEach((players: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(players.player, 'image');
            JsonService.deriveFullUrl(players.player, 'profile');
          });
          return bookingByPlayer;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addPlayerToBooking(bookingId: number, playerInfo: any, sequence?: string) {
    let _params = {};
    console.debug('service : add player to booking ', bookingId, playerInfo, sequence);
    _params['bookingId'] = bookingId;
    let _caddySelectionCriteria;
    if (playerInfo?.playerDetails?.caddySelectionCriteria)
      _caddySelectionCriteria = playerInfo?.playerDetails?.caddySelectionCriteria;
    if (playerInfo?.new) {
      _params['playerName'] = playerInfo?.playerDetails?.playerName;
      _params['email'] = playerInfo?.playerDetails?.email;
      _params['gender'] = playerInfo?.playerDetails?.gender;
      _params['phone'] = playerInfo?.playerDetails?.phone;
      _params['playerContact'] =
        playerInfo?.playerContact && playerInfo?.playerContact?.playerContact
          ? playerInfo?.playerContact?.playerContact
          : '';
      if (playerInfo?.playerDetails)
        _params['walking'] = playerInfo?.playerDetails?.walking
          ? playerInfo?.playerDetails?.walking
          : false;
      if (playerInfo?.playerDetails)
        _params['caddySelectionCriteria.caddyRequired'] = _caddySelectionCriteria?.caddyRequired
          ? _caddySelectionCriteria?.caddyRequired
          : false;
    } else if (!playerInfo?.new) {
      _params['player.id'] = playerInfo.playerId;
      if (playerInfo?.playerDetails)
        _params['walking'] = playerInfo?.playerDetails?.walking
          ? playerInfo?.playerDetails?.walking
          : false;
      if (playerInfo?.playerDetails)
        _params['caddySelectionCriteria.caddyRequired'] = _caddySelectionCriteria?.caddyRequired
          ? _caddySelectionCriteria?.caddyRequired
          : false;
    }
    let request = new RemoteRequest(
      global.ServerUrls.addPlayerToBooking,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public deletePlayerFromBooking(bookingPlayerId: number) {
    let _bookingPlayerId = bookingPlayerId;
    let _params;
    _params = '?bookingPlayerId=' + _bookingPlayerId;
    let request = new RemoteRequest(
      global.ServerUrls.deletePlayerFromBooking + _params,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getClubBookingOptions(clubId: number, forDate: string) {
    let request = new RemoteRequest(
      global.ServerUrls.getClubBookingOptions,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
        forDate: forDate,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingOptions: TeeTimeBookingOptions = resp;
          return bookingOptions;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getPlayerById(id: number) {
    let _params = '?playerId=' + id;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerById + _params,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {}
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: PlayerData = resp;
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerByMembership(id: string, clubId: number) {
    let _params = '?membership=' + id + '&clubId=' + clubId;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerByMembership + _params,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {}
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: PlayerData = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public searchPlayerByMembership(id: string, clubId: number) {
    let _params = {};
    _params['membership'] = id;
    _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.searchPlayerByMembership,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: Array<PlayerData> = resp;
          player.forEach((p: PlayerData) => {
            JsonService.deriveFulImageURL(p, 'image');
            JsonService.deriveFulImageURL(p, 'profile');
          });
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateBookingPlayerContact(bookingPlayerId: number, playerInfo: any) {
    let _params = {};
    _params['bookingPlayerId'] = bookingPlayerId;
    if (playerInfo.new) {
      _params['address1'] = playerInfo.playerDetails.address.address1;
      _params['address2'] = playerInfo.playerDetails.address.address2;
      _params['city'] = playerInfo.playerDetails.address.city;
      _params['state'] = playerInfo.playerDetails.address.state;
      _params['postCode'] = playerInfo.playerDetails.address.postCode;
      _params['phone1'] = playerInfo.playerDetails.address.phone1;
      _params['phone2'] = playerInfo.playerDetails.address.phone2;
    } else if (!playerInfo.new) {
      _params['address1'] = playerInfo.playerDetails.address.address1;
      _params['address2'] = playerInfo.playerDetails.address.address2;
      _params['city'] = playerInfo.playerDetails.address.city;
      _params['state'] = playerInfo.playerDetails.address.state;
      _params['postCode'] = playerInfo.playerDetails.address.postCode;
      _params['countryData.id'] = playerInfo.playerDetails.address.countryData.id;
      _params['phone1'] = playerInfo.playerDetails.address.phone1;
      _params['phone2'] = playerInfo.playerDetails.address.phone2;
    }
    let request = new RemoteRequest(
      global.ServerUrls.updateBookingPlayerContact,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  updateBookingPlayerDetails(
    bookingId: number,
    player: TeeTimeBookingPlayer,
    type?: string,
    bookingOptions?: TeeTimeBookingOptions
  ) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['id'] = player.id;
    _params['playerName'] = player.playerName;
    _params['gender'] = player.gender;
    _params['email'] = player.email;
    _params['sequence'] = player.sequence;
    _params['pairingNo'] = player.pairingNo;
    _params['playerContact'] = player.playerContact;
    _params['caddyPairing'] = player.caddyPairing;
    _params['walking'] = player.pairingNo === 0 ? true : false;
    _params['driving'] = player.driving;
    _params['caddySelectionCriteria.gender'] =
      player.caddySelectionCriteria && player.caddySelectionCriteria.gender
        ? player.caddySelectionCriteria.gender
        : null;
    _params['caddySelectionCriteria.maxAge'] =
      player.caddySelectionCriteria && player.caddySelectionCriteria.maxAge
        ? player.caddySelectionCriteria.maxAge
        : null;
    _params['caddySelectionCriteria.minAge'] =
      player.caddySelectionCriteria && player.caddySelectionCriteria.minAge
        ? player.caddySelectionCriteria.minAge
        : null;
    switch (type) {
      case 'driving':
        _params['caddyPreferred.id'] =
          player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['driving'] = player.driving;
        _params['caddyPairing'] = player.caddyPairing;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'caddyPreferred':
        _params['caddyPreferred.id'] =
          player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['caddyPairing'] = player.caddyPairing;
        _params['caddySelectionCriteria.caddyRequired'] = true;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'pairing':
        _params['caddyPreferred.id'] = player.caddyPreferred ? player.caddyPreferred.id : null;
        _params['pairingNo'] = player.pairingNo;
        _params['caddyPairing'] = player.caddyPairing;
        break;
      case 'caddyPairing':
        _params['caddyPairing'] = player.caddyPairing;
        _params['caddyPreferred.id'] =
          player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['caddySelectionCriteria.caddyRequired'] = true;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'removeCaddy':
        _params['caddyPreferred.id'] = null;
        _params['caddySelectionCriteria.caddyRequired'] = false;
        _params['pairingNo'] = player.pairingNo;
        break;
      case 'playerType':
        _params['caddyPreferred.id'] =
          player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['driving'] = player.driving;
        _params['caddyPairing'] = player.caddyPairing;
        _params['pairingNo'] = player.pairingNo;
        _params['playerTypeUsed.id'] = player['playerTypeUsed.id'];
        _params['caddySelectionCriteria.gender'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.gender
            ? player.caddySelectionCriteria.gender
            : null;
        _params['caddySelectionCriteria.maxAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.maxAge
            ? player.caddySelectionCriteria.maxAge
            : null;
        _params['caddySelectionCriteria.minAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.minAge
            ? player.caddySelectionCriteria.minAge
            : null;
        break;
      case 'clear':
        _params['caddyPreferred.id'] = null;
        if (bookingOptions && !bookingOptions.buggyMandatory) _params['pairingNo'] = 0;
        if (bookingOptions && !bookingOptions.caddyMandatory) _params['caddyPairing'] = 0;
        _params['caddySelectionCriteria.caddyRequired'] = false;
        _params['caddySelectionCriteria.gender'] = '';
        _params['caddySelectionCriteria.minAge'] = null;
        _params['caddySelectionCriteria.maxAge'] = null;
        break;
      case 'resetProfile':
        _params['caddyPreferred.id'] =
          player.caddyPreferred && player.caddyPreferred.id ? player.caddyPreferred.id : null;
        _params['driving'] = player.driving;
        _params['caddyPairing'] = player.caddyPairing;
        _params['pairingNo'] = player.pairingNo;
        _params['caddySelectionCriteria.gender'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.gender
            ? player.caddySelectionCriteria.gender
            : null;
        _params['caddySelectionCriteria.maxAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.maxAge
            ? player.caddySelectionCriteria.maxAge
            : null;
        _params['caddySelectionCriteria.minAge'] =
          player.caddySelectionCriteria && player.caddySelectionCriteria.minAge
            ? player.caddySelectionCriteria.minAge
            : null;
        break;
      case 'hasInsurance':
        _params['playerHasInsurance'] = player.playerHasInsurance;
        break;
    }
    let request = new RemoteRequest(
      global.ServerUrls.updateBookingPlayerDetails,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public addFromGroup(bookingId: number, groupId: number) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['playerGroup'] = groupId;
    let request = new RemoteRequest(
      global.ServerUrls.addFromGroup,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public cancelBooking(bookingId: number, cancelledByClub: boolean, reasonText?: string) {
    let _params = {};
    let _reason;
    if (!reasonText || reasonText === null) {
      if (cancelledByClub) _reason = 'Cancelled by Club';
      else _reason = 'Cancelled by Player';
    } else _reason = reasonText;
    if (bookingId) _params['bookingId'] = bookingId;
    _params['cancelledByClub'] = cancelledByClub;
    _params['reason'] = _reason;

    let request = new RemoteRequest(
      global.ServerUrls.cancelBooking,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public cancelBookingByClub(cancelBookingSpec: CancelBookingSpecification) {
    let _params = {};
    let _reason;
    if (cancelBookingSpec) _params = cancelBookingSpec;
    let request = new RemoteRequest(
      global.ServerUrls.cancelBookingByClub,
      this.requestMethod.post,
      ContentType.JSON,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public checkinBooking(
    bookingId: number,
    arrivingIn: number,
    bookingPlayerId: Array<number>,
    byClub: boolean = false
  ) {
    let _params;
    let _arrivingIn = arrivingIn ? arrivingIn : 0;
    let _bookingPlayerId = bookingPlayerId;
    let _byClub;
    let _paramBookingPlayer;
    _paramBookingPlayer =
      'bookingId=' + bookingId + '&arrivingIn=' + _arrivingIn + '&byClub=' + byClub;
    _bookingPlayerId.forEach((v, i) => {
      _paramBookingPlayer += '&bookingPlayerId=' + v;
    });
    let request = new RemoteRequest(
      global.ServerUrls.checkinBooking + '?' + _paramBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public processBookingAssignments(bookingId: number) {
    let request = new RemoteRequest(
      global.ServerUrls.processBookingAssignments,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        bookingId: bookingId,
      }
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerByEmail(email: string) {
    let _params = {};
    if (email) _params['email'] = email;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerByEmail,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: PlayerInfo = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateBuggyCaddiePreference(bookingBuggyCaddyPref: BuggyCaddiePreference) {
    let _params: BuggyCaddiePreference;
    if (bookingBuggyCaddyPref) {
      _params = bookingBuggyCaddyPref;
      _params.playerPairings.forEach(pp => {
        pp.caddyAssigned = null;
        pp.caddyPreferred = null;
      });
    }

    let request = new RemoteRequest(
      global.ServerUrls.updateBuggyCaddyPreference,
      this.requestMethod.post,
      ContentType.JSON,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public updateBookingFlightStatus(bookingId: number, status: string) {
    let _status = status ? status : null;
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['status'] = _status;
    let request = new RemoteRequest(
      global.ServerUrls.updateBookingFlightStatus,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getBookingItemizedBill(bookingId: number, afterAssignment: boolean) {
    let _params = {};
    _params['bookingId'] = bookingId;
    let _afterAssignment;
    _afterAssignment = '&afterAssignment=' + afterAssignment ? 'true' : 'false';
    let request = new RemoteRequest(
      global.ServerUrls.getBookingItemizedBill +
        '/' +
        bookingId +
        '?afterAssignment=' +
        afterAssignment,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public cancelBookingAssignments(bookingId: number) {
    let request = new RemoteRequest(
      global.ServerUrls.cancelBookingAssignments,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        bookingId: bookingId,
      }
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public changeBuggy(bookingId: number, bookingPlayersId: Array<number>, buggyId: number) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (bookingPlayersId) _params['bookingPlayerId'] = bookingPlayersId.join(',');
    if (buggyId) _params['buggyId'] = buggyId;
    let _paramBookingPlayer;
    _paramBookingPlayer = 'bookingId=' + bookingId + '&buggyId=' + buggyId;
    bookingPlayersId.forEach((v, i) => {
      _paramBookingPlayer += '&bookingPlayerId=' + v;
    });
    let request = new RemoteRequest(
      global.ServerUrls.changeBuggyFlight + '?' + _paramBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingObject: TeeTimeBooking = resp;
          bookingObject.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(player.player, 'image');
            JsonService.deriveFullUrl(player.player, 'profile');
            JsonService.deriveFullUrl(player.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(player.caddyPreferred, 'caddyImage');
          });

          return {
            resp,
            bookingObject,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public changeCaddy(bookingId: number, bookingPlayersId: Array<number>, caddieId: number) {
    let _params = {};
    _params['bookingId'] = bookingId;
    _params['bookingPlayerId'] = bookingPlayersId.join(',');
    _params['caddieId'] = caddieId;

    let _paramBookingPlayer;
    _paramBookingPlayer = 'bookingId=' + bookingId + '&caddieId=' + caddieId;
    bookingPlayersId.forEach((v, i) => {
      _paramBookingPlayer += '&bookingPlayerId=' + v;
    });
    let request = new RemoteRequest(
      global.ServerUrls.changeCaddyFlight + '?' + _paramBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingObject: TeeTimeBooking = resp;
          bookingObject.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
            JsonService.deriveFullUrl(player.player, 'image');
            JsonService.deriveFullUrl(player.player, 'profile');
            JsonService.deriveFullUrl(player.caddyAssigned, 'caddyImage');
            JsonService.deriveFullUrl(player.caddyPreferred, 'caddyImage');
          });
          return { resp, bookingObject };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBuggyDayDetails(clubId: number, forDate: string) {
    let _params = {};
    _params['clubId'] = clubId;
    _params['forDate'] = forDate;
    let request = new RemoteRequest(
      global.ServerUrls.getBuggyDayDetails,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let buggyDayDetails: Array<BuggyDayDetails> = resp;
          buggyDayDetails.forEach((buggy: BuggyDayDetails) => {
            JsonService.deriveFullUrl(buggy.buggy, 'buggyImage');
          });
          return buggyDayDetails;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddieDayDetails(clubId: number, forDate: string) {
    let _params = {};
    _params['clubId'] = clubId;
    _params['forDate'] = forDate;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyDayDetails,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyDayDetails: Array<CaddyDayDetails> = resp;
          caddyDayDetails.forEach((caddy: CaddyDayDetails) => {
            JsonService.deriveFullUrl(caddy.caddy, 'caddyImage');
          });
          return caddyDayDetails;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public changeSlot(bookingId: number, newSlot: TeeTimeSlotDisplay) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (newSlot) _params['slotDayId'] = newSlot.slot.slotDayId;
    if (newSlot) _params['slotNo'] = newSlot.slot.slotNo;

    let request = new RemoteRequest(
      global.ServerUrls.changeSlot,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public swapFlightSlot(bookingId: number, swapBookingId: number) {
    let _params = {};
    if (bookingId) _params['firstBookingId'] = bookingId;
    if (swapBookingId) _params['secondBookingId'] = swapBookingId;
    let request = new RemoteRequest(
      global.ServerUrls.swapFlightSlot,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public moveSlot(bookingId: number, newSlot: TeeTimeSlotDisplay) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (newSlot) _params['teeOffDate'] = newSlot.slot.teeOffDate;
    if (newSlot) _params['slotNo'] = newSlot.slot.slotNo;

    let request = new RemoteRequest(
      global.ServerUrls.moveFlightSlot,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public rateForClub(clubId: number, clubRating: ClubRating) {
    let _params = {};
    if (clubRating) _params = clubRating;
    let request = new RemoteRequest(
      global.ServerUrls.rateForClub + '/' + clubId,
      this.requestMethod.post,
      ContentType.JSON,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public rateForCaddy(caddieId: number, rating: number, playerId: number, comment: string) {
    let _params = {};
    if (rating) _params['rating'] = rating;
    if (playerId) _params['playerId'] = playerId;
    if (comment) _params['comment'] = comment;
    let request = new RemoteRequest(
      global.ServerUrls.rateForCaddie +
        '/' +
        caddieId +
        '?rating=' +
        _params['rating'] +
        '&playerId=' +
        _params['playerId'],
      this.requestMethod.post,
      ContentType.PLAIN_TEXT,
      comment
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubRatingItems(clubId: number) {
    let _params = {};
    _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.getClubRatingItems + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let ratingItems: Array<RatingItem> = resp;
          return ratingItems;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingStatsWithPlayerInfo(
    clubId: number,
    startDate?: string,
    endDate?: string,
    courseId?: number
  ) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getBookingStats + '/' + clubId + global.ServerUrls.getBookStatPlayerInfo,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingStats: BookingStatistics = resp;
          return bookingStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingStats(
    clubId: number,
    startDate?: string,
    endDate?: string,
    revenueFuture?: boolean
  ) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (!revenueFuture) {
      _params['statusValues'] = [];
      _params['statusValues'].push(...['D', 'H', 'P', 'R']);
    }

    let request = new RemoteRequest(
      global.ServerUrls.getBookingStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingStats: BookingStatistics = resp;
          return bookingStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCourseUtilStats(
    clubId: number,
    startDate?: string,
    endDate?: string,
    courseId?: number
  ) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getCourseUtilStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let courseUtilStats: CourseUtilizationStatistics = resp;
          return courseUtilStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddyBuggyUtilStats(
    clubId: number,
    startDate?: string,
    endDate?: string,
    courseId?: number
  ) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyBuggyStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddieBuggyAsgmtStats: CaddieBuggyAssignmentStatistics = resp;
          return caddieBuggyAsgmtStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddyBuggyDayStats(
    clubId: number,
    startDate?: string,
    endDate?: string,
    courseId?: number
  ) {
    let _params = {};
    _params['startDate'] = startDate;
    _params['endDate'] = endDate;
    if (courseId) _params['courseId'] = courseId;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyBuggyDayStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddieBuggyAsgmtStats: CaddieBuggyStatistics = resp;
          return caddieBuggyAsgmtStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getFutureStats(clubId: number) {
    let _params = {};
    let request = new RemoteRequest(
      global.ServerUrls.getFutureStats + '/' + clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let futureStats: FutureBookingStatistics = resp;
          return futureStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getFAQ(jsonUrl?: string) {
    let _jsonUrl = '/document/assets/faq.json';
    if (jsonUrl) _jsonUrl = jsonUrl;
    let request = new RemoteRequest(global.MygolfServer + _jsonUrl, this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let groupItems: Array<GroupItem> = resp;
          return groupItems;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getContactUs(jsonUrl?: string) {
    let _jsonUrl = '/document/assets/contact-us.json';
    if (jsonUrl) _jsonUrl = jsonUrl;
    let request = new RemoteRequest(global.MygolfServer + _jsonUrl, this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let contactUsItem: ContactUsItem = resp;
          return contactUsItem;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getHelp(jsonUrl?: string) {
    let _jsonUrl = '/document/assets/help.json';
    _jsonUrl = jsonUrl;
    let request = new RemoteRequest(global.MygolfServer + _jsonUrl, this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let helpURL;
          let _data: Array<HelpURLs> = resp;
          helpURL = _data
            .map(h => {
              return h;
            })
            .filter(h => {
              return (
                h.server.toLowerCase() === global.MygolfServerHost.toLowerCase() &&
                h?.version === 'V5'
              );
            });
          return helpURL;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getClubHelp(jsonUrl?: string) {
    let _jsonUrl = '/document/assets/clubHelp.json';
    if (jsonUrl) _jsonUrl = jsonUrl;

    let request = new RemoteRequest(global.MygolfServer + _jsonUrl, this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubHelpItem: Array<ClubHelpItem> = resp;
          return clubHelpItem;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public clubBookingSlot(
    reqBookSlot?: TeeTimeSlotBookingRequest,
    addBookingPlayer: boolean = true,
    captchaResponse?: string
  ): Observable<any> {
    let _reqBookSlot = reqBookSlot;
    let headers = {};
    if (captchaResponse && captchaResponse.length > 0)
      headers['captcha-response'] = captchaResponse;
    else headers = null;
    let _addBookingPlayer = '?addBookingPlayer=' + (addBookingPlayer ? 'true' : 'false');
    let request = new RemoteRequest(
      global.ServerUrls.clubBookingSlot,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      reqBookSlot,
      headers
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public clubRegisterUser(params: any) {
    let _params = {};
    _params = params ? params : {};
    let request = new RemoteRequest(
      global.ServerUrls.clubRegisterUser,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public clubCapturePayment(bookingOfflinePayment: BookingOfflinePayment) {
    let _params = {};
    _params = bookingOfflinePayment ? bookingOfflinePayment : {};
    let request = new RemoteRequest(
      global.ServerUrls.clubCapturePayment,
      this.requestMethod.post,
      ContentType.JSON,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getCaddyRatings(caddyId: number, fromDate: string, toDate?: string) {
    let _params = {};
    let _caddyId = caddyId ? '/' + caddyId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyRatings + _caddyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let contactUsItem: ContactUsItem = resp;
          return contactUsItem;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddyAssignments(caddyId: number, fromDate: string, toDate?: string) {
    let _params = {};
    let _caddyId = caddyId ? '/' + caddyId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyAssignments + _caddyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyAssignment: Array<CaddyAssignment> = resp;
          return {
            resp,
            caddyAssignment,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddyInfo(caddyId?: number) {
    let _caddyId = caddyId ? '/' + caddyId : '';
    let request = new RemoteRequest(
      global.ServerUrls.getCaddyInfo + _caddyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let contactUsItem: ContactUsItem = resp;
          return contactUsItem;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListClubPlayerVouchers(clubId?: number, playerId?: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.listActiveClubPlayerVouchers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let voucherList: Array<TeeTimeClubVoucher> = resp;
          return voucherList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public setRefundBookingPlayer(
    bookingId: number,
    playerId: number,
    amount: number,
    reason: string,
    refundMode: string = 'CASH',
    refundReason: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (playerId) _params['playerId'] = playerId;
    if (amount) _params['amount'] = amount;
    if (reason) _params['reason'] = reason;
    if (refundMode) _params['refundMode'] = refundMode;
    if (refundReason) _params['refundReason'] = refundReason;
    if (validUntil) _params['refundValidUntil'] = validUntil;

    let request = new RemoteRequest(
      global.ServerUrls.setRefundBookingPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public setRefundWalletBalance(params): Observable<any> {
    let _params = {};
    if (params) _params = params;

    let request = new RemoteRequest(
      global.ServerUrls.playerClubWallet.refundWalletBalance,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public applyPlayerBookingVoucher(
    bookingId: number,
    voucherId: number,
    force?: boolean
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (voucherId) _params['voucherId'] = voucherId;
    if (force) _params['force'] = force;

    let request = new RemoteRequest(
      global.ServerUrls.applyPlayerBookingVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public removePlayerBookingVoucher(bookingId: number, voucherId: number): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (voucherId) _params['voucherId'] = voucherId;

    let request = new RemoteRequest(
      global.ServerUrls.removePlayerBookingVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubVoucherSeries(
    url: number,
    clubId: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    showAll?: boolean
  ) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (pageNo) _params['pageNo'] = pageNo;
    if (pageSize) _params['pageSize'] = pageSize;
    if (search) _params['search'] = search;
    if (showAll) _params['activeOnly'] = false;
    let _url;
    if (url === 1) _url = global.ServerUrls.listClubVoucherSeries;
    if (url === 2) _url = 'assets/club-voucher-series.json';
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          // console.debug("service : get club voucher series ", resp)
          let voucherSeriesPage: VoucherSeriesPage = resp;
          if (voucherSeriesPage?.items) {
            voucherSeriesPage.items.forEach((vs: TeeTimeClubVoucherSeries) => {
              JsonService.deriveFulImageURL(vs, 'voucherImage');
            });
          }
          return voucherSeriesPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public assignClubPlayerVoucher(
    clubId: number,
    playerId: number,
    voucherSeriesId: number,
    numberOfVouchers: number,
    validFrom?: string
  ): Observable<any> {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (voucherSeriesId) _params['voucherSeriesId'] = voucherSeriesId;
    if (numberOfVouchers) _params['numberOfVouchers'] = numberOfVouchers;
    if (validFrom) _params['validFrom'] = validFrom;

    let request = new RemoteRequest(
      global.ServerUrls.assignClubPlayerVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListPlayerVouchers(playerId?: number, activeAsOf?: string) {
    console.log('getListPlayerVouchers: ');
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (activeAsOf) _params['activeAsOf'] = activeAsOf;
    let request = new RemoteRequest(
      global.ServerUrls.listActivePlayerVouchers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let voucherList: Array<TeeTimeClubVoucher> = resp;
          return voucherList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListClubDiscounts(clubId: number, search?: string, pageSize?: number, pageNo?: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (search) _params['search'] = search;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    let request = new RemoteRequest(
      global.ServerUrls.listClubDiscounts,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let listClubDiscount: any = resp;
          return listClubDiscount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getActiveListClubDiscounts(clubId: number, effectiveDate?: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (effectiveDate) _params['effectiveDate'] = effectiveDate;
    let request = new RemoteRequest(
      global.ServerUrls.listActiveDiscounts,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let listClubDiscount: any = resp;
          return listClubDiscount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public unassignClubPlayerVoucher(
    clubId: number,
    playerId: number,
    voucherIds: Array<number>
  ): Observable<any> {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (voucherIds) _params['voucherIds'] = voucherIds;
    let request = new RemoteRequest(
      global.ServerUrls.unassignClubPlayerVoucher,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getApplicableClubPlayerTypes(clubId: number, playerId: number, effectiveDate?: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (effectiveDate) _params['effectiveDate'] = effectiveDate;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerClubApplicablePlayerTypes,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: any = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubApplicablePlayerTypes(clubId?: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.getClubApplicablePlayerTypes,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: any = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public applyPlayerBookingDiscount(
    bookingId: number,
    discountId: number,
    bookingPlayerId?: number,
    force?: boolean
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (discountId) _params['discountId'] = discountId;
    if (bookingPlayerId) _params['bookingPlayerId'] = bookingPlayerId;
    if (force) _params['force'] = force;

    let request = new RemoteRequest(
      global.ServerUrls.applyPlayerBookingDiscount,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public removePlayerBookingDiscount(
    bookingId: number,
    discountId: number,
    bookingPlayerId?: number
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (discountId) _params['discountId'] = discountId;
    if (bookingPlayerId) _params['bookingPlayerId'] = bookingPlayerId;

    let request = new RemoteRequest(
      global.ServerUrls.removePlayerBookingDiscount,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getDiscountCompanies(search?: string, pageSize: number = 30, pageNo: number = 1) {
    let _params = {};
    if (search) _params['search'] = search;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    let request = new RemoteRequest(
      global.ServerUrls.listDiscountCompanies,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let discountCompanies: PagedData<DiscountCompany> = resp;

          discountCompanies.items.forEach((dc: DiscountCompany) => {
            if (dc && dc.partnerImage) JsonService.deriveFulImageURL(dc, 'partnerImage');
          });
          return discountCompanies;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public createPlayerDiscountCard(
    playerId: number,
    programId: string,
    membershipNo?: string,
    validFrom?: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (membershipNo) _params['membershipNo'] = membershipNo;
    if (validFrom) _params['validFrom'] = validFrom;
    if (validUntil) _params['validUntil'] = validUntil;
    let request = new RemoteRequest(
      global.ServerUrls.createPlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deletePlayerDiscountCard(playerDiscountId: number): Observable<any> {
    let _params = {};
    if (playerDiscountId) _params['playerDiscountId'] = playerDiscountId;
    let request = new RemoteRequest(
      global.ServerUrls.deletePlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public applyForClubVerifyDiscountCard(
    playerId: number,
    programId: string,
    clubId?: number
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (clubId) _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.applyForClubVerifyDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public approvePlayerDiscountCard(
    playerId: number,
    playerDiscountProgramId: Array<number>,
    clubId: number,
    validFrom?: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (playerDiscountProgramId) _params['playerDiscountProgramId'] = playerDiscountProgramId;
    if (clubId) _params['clubId'] = clubId;
    if (validFrom) _params['validFrom'] = validFrom;
    if (validUntil) _params['validUntil'] = validUntil;
    let re = /:clubId/gi;
    let _url = global.ServerUrls.approvePlayerDiscountCard;
    _url = _url.replace(re, _params['clubId']);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public approveMultiPlayerDiscountCard(
    playerId: number,
    programId: string,
    clubId: number,
    validFrom?: string,
    validUntil?: string
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (clubId) _params['clubId'] = clubId;
    if (validFrom) _params['validFrom'] = validFrom;
    if (validUntil) _params['validUntil'] = validUntil;
    let request = new RemoteRequest(
      global.ServerUrls.approveMultiPlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public undoApprovePlayerDiscountCard(
    playerId: number,
    programId: string,
    clubId: number,
    pdpId?: number
  ): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (clubId) _params['clubId'] = clubId;
    if (pdpId) _params['playerDiscountProgramId'] = pdpId;
    let request = new RemoteRequest(
      global.ServerUrls.undoApprovePlayerDiscountCard,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerDiscountPrograms(playerId: string) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.listPlayerDiscountPrograms,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let pdp: Array<PlayerDiscountProgram> = resp;
          if (pdp && pdp.length > 0)
            pdp.forEach((p: PlayerDiscountProgram) => {
              JsonService.deriveFulImageURL(p, 'document');
              JsonService.deriveFulImageURL(p.discountProgram.discountCompany, 'partnerImage');
            });
          return pdp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listDiscountProgramsClub(programId: string) {
    let _params = {};
    if (programId) _params['programId'] = programId;
    let request = new RemoteRequest(
      global.ServerUrls.listDiscountProgramsClub,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getDiscountPrograms(companyId: string) {
    let _params = {};
    if (companyId) _params['companyId'] = companyId;
    let request = new RemoteRequest(
      global.ServerUrls.listDiscountPrograms,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: PlayerData = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerCredits(playerId: number) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerCredits,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: PlayerData = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerClubCredits(playerId: number, clubId: number) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (clubId) _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerClubCredits,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: any = resp;

          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getVouchersIssued(
    clubId: number,
    seriesId?: number,
    search?: string,
    includeRedeemed: boolean = false,
    includeExpired: boolean = false,
    pageSize: number = 999,
    pageNo: number = 1
  ) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (seriesId) _params['seriesId'] = seriesId;
    if (search) _params['search'] = search;
    if (includeRedeemed) _params['includeRedeemed'] = includeRedeemed;
    if (includeExpired) _params['includeExpired'] = includeExpired;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;

    let request = new RemoteRequest(
      global.ServerUrls.listClubVouchersIssued,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let voucherIssued: Array<TeeTimeClubVoucher> = resp;
          return voucherIssued;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public redeemPlayerClubCredit(
    bookingId: number,
    playerId: number,
    amount: number,
    bypassWallet?: boolean
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (playerId) _params['playerId'] = playerId;
    if (amount) _params['amount'] = amount;
    if (bypassWallet) _params['bypassWallet'] = bypassWallet;
    let request = new RemoteRequest(
      global.ServerUrls.redeemClubCredit,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListAllCardApplyForPlayer(
    playerId: number,
    programId: string,
    pendingOnly: boolean = false,
    includeExpired: boolean = false
  ) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (programId) _params['programId'] = programId;
    if (pendingOnly) _params['pendingOnly'] = pendingOnly;
    if (includeExpired) _params['includeExpired'] = includeExpired;

    let request = new RemoteRequest(
      global.ServerUrls.listAllCardApplyForPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListAllPlayersCardDiscount(
    clubId: number,
    programId?: string,
    pendingOnly: boolean = false,
    includeExpired: boolean = false
  ) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (programId) _params['programId'] = programId;
    if (pendingOnly) _params['pendingOnly'] = pendingOnly;
    if (includeExpired) _params['includeExpired'] = includeExpired;

    let request = new RemoteRequest(
      global.ServerUrls.listAllPlayersCardDiscount,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListClubDiscountProgram(clubId: number, programId: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (programId) _params['programId'] = programId;

    let request = new RemoteRequest(
      global.ServerUrls.listClubDiscountProgram,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getApplicableDiscountsForPlayer(clubId: number, playerId: number, effectiveDate?: string) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (effectiveDate) _params['effectiveDate'] = effectiveDate;

    let request = new RemoteRequest(
      global.ServerUrls.getApplicableDiscountsForPlayer,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let listClubDiscount: any = resp;
          return listClubDiscount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updatePlayerCardDocument(
    imageURL: string,
    contentType: string,
    playerDiscountProgramId: number,
    authToken?: string
  ): Observable<UploadResult> {
    let _pDiscountProgId;
    if (playerDiscountProgramId) _pDiscountProgId = '?id=' + playerDiscountProgramId;
    let options = {
      file: imageURL,
      authToken: authToken,
    };
    return from(
      this.ftService.uploadFile(
        imageURL,
        global.ServerUrls.updatePlayerDiscountDocument + _pDiscountProgId,
        contentType,
        options
      )
    );
  }

  public addPlayerType(
    imageURL: string,
    contentType: string,
    playerId: number,
    bookingPlayerType: string,
    authToken?: string
  ): Observable<UploadResult> {
    let _playerId;
    let _playerType;
    if (playerId) _playerId = 'playerId=' + playerId;
    if (bookingPlayerType) _playerType = '&bookingPlayerType=' + bookingPlayerType;
    let options = {
      file: imageURL,
      authToken: authToken,
    };

    return from(
      this.ftService.uploadFile(
        imageURL,
        global.ServerUrls.assignBookingPlayerType + '?' + _playerId + _playerType,
        contentType,
        options
      )
    );
  }

  public addPlayerInsuranceDocument(
    imageURL: string,
    contentType: string,
    playerId: number,
    authToken?: string,
    params?: any,
    file?: any
  ): Observable<any> {
    let _pDiscountProgId;
    let _url = global.ServerUrls.playerInsurance.addInsurance;
    let rePlayer = /:playerId/gi;
    _url = _url.replace(rePlayer, playerId);

    if (1) {
      // !this.platform.is('capacitor')
      const _formData: FormData = new FormData();
      _formData.append('insuranceDocument', file);
      _formData.append('name', params.name);
      _formData.append('insuranceNo', params.insuranceNo);
      _formData.append('startDate', params.startDate);
      _formData.append('endDate', params.endDate);
      _formData.append('playerId', String(playerId));
      _formData.append('insuranceCompanyName', params.insuranceCompanyName);
      _formData.append('insuranceCompanyId', params.insuranceCompanyId);
      _formData.append('applicableIn', params.applicableIn);
      let _hdrs = {
        'Content-Type': 'multipart/form-data',
      };
      let request = new RemoteRequest(
        _url,
        this.requestMethod.post,
        ContentType.MULTIPART_FORM,
        _formData
      );
      return this.http
        .execute(request)
        .pipe(
          map((resp: any) => {
            console.debug('after uploading insurance : ', resp);
            return resp;
          })
        )
        .pipe(catchError(this.http.handleError));
    } else {
      let options = {
        insuranceDocument: imageURL,
        file: imageURL,
        authToken: authToken,
      };

      options = Object.assign(options, params);
      return from(this.ftService.uploadFile(imageURL, _url, contentType, options, 'insurance'));
    }
  }

  public updatePlayerInsuranceDocument(
    imageURL: string,
    contentType: string,
    playerId: number,
    insuranceId: number,
    authToken?: string,
    params?: any,
    file?: any
  ): Observable<any> {
    let _url = global.ServerUrls.playerInsurance.updateDeleteInsurance;
    let rePlayer = /:playerId/gi;
    let reInsurance = /:insuranceId/gi;
    _url = _url.replace(rePlayer, playerId);
    _url = _url.replace(reInsurance, insuranceId);
    if (1) {
      // !this.platform.is('capacitor')
      let options = {
        insuranceDocument: file,
        authToken: authToken,
      };

      options = Object.assign(options, params);
      const _formData: FormData = new FormData();
      _formData.append('insuranceDocument', file);
      _formData.append('name', params.name);
      _formData.append('insuranceNo', params.insuranceNo);
      _formData.append('startDate', params.startDate);
      _formData.append('endDate', params.endDate);
      _formData.append('playerId', String(playerId));
      _formData.append('insuranceCompanyName', params.insuranceCompanyName);
      _formData.append('insuranceCompanyId', params.insuranceCompanyId);
      _formData.append('applicableIn', params.applicableIn);
      let _hdrs = {
        'Content-Type': 'multipart/form-data',
      };

      console.debug('updating player insurance ', file, _formData, params);
      let request = new RemoteRequest(
        _url,
        this.requestMethod.post,
        ContentType.MULTIPART_FORM,
        _formData
      );
      return this.http
        .execute(request)
        .pipe(map((resp: any) => resp))
        .pipe(catchError(this.http.handleError));
    } else {
      let options = {
        insuranceDocument: imageURL,
        file: imageURL,
        authToken: authToken,
      };

      options = Object.assign(options, params);
      return from(this.ftService.uploadFile(imageURL, _url, contentType, options, 'insurance'));
    }
  }
  public recalculateBookingPricing(bookingId: number, ignoreDate?: boolean) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (ignoreDate) _params['ignoreDate'] = ignoreDate;

    let request = new RemoteRequest(
      global.ServerUrls.recalculateBookingPricing,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingObject: any = resp;

          return bookingObject;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public bookingWaiveOff(bookingId: number, amount: number, reason?: string): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (amount) _params['amount'] = amount;
    if (reason) _params['reason'] = reason;

    let request = new RemoteRequest(
      global.ServerUrls.bookingWaiveOff,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public undoBookingWaiveOff(bookingId: number, sequence: number): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (sequence) _params['sequence'] = sequence;

    let request = new RemoteRequest(
      global.ServerUrls.undoBookingWaiveOff,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public assignBookingPlayerType(playerId: number, bookingPlayerType: string): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (bookingPlayerType) _params['bookingPlayerType'] = bookingPlayerType;

    let request = new RemoteRequest(
      global.ServerUrls.assignBookingPlayerType,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public assignableBookingPlayerType() {
    let _params = {};
    let request = new RemoteRequest(
      global.ServerUrls.assignableBookingPlayerType,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listBookingPlayerType(clubId?: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    let request = new RemoteRequest(
      global.ServerUrls.listBookingPlayerType,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public assignedBookingPlayerType(playerId: number) {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.assignedBookingPlayerType,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<any> = resp;
          data.forEach(d => {
            JsonService.deriveFulImageURL(d, 'supportingDocument');
          });
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public removeBookingPlayerType(playerId: number, bookingPlayerType: string): Observable<any> {
    let _params = {};
    if (playerId) _params['playerId'] = playerId;
    if (bookingPlayerType) _params['bookingPlayerType'] = bookingPlayerType;
    let request = new RemoteRequest(
      global.ServerUrls.removeBookingPlayerType,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getClubMembersList(clubId: number, params?: any) {
    let _params = {};
    let _status;

    if (params['activeOnly']) _params['activeOnly'] = params['activeOnly'];
    if (params['search']) _params['search'] = params['search'];
    if (params['status']) _status = params['status'];
    if (params['membershipTypes']) _params['membershipTypes'] = params['membershipTypes'];
    let _clubMembersURL = global.ServerUrls.listClubMembership + '/' + clubId;
    if (_status) _clubMembersURL += '/' + _status;
    let request = new RemoteRequest(
      _clubMembersURL,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<ClubMembership> = resp;
          data.forEach((d: ClubMembership) => {
            JsonService.deriveFulImageURL(d.player, 'profile');
            JsonService.deriveFulImageURL(d.player, 'image');
            JsonService.deriveFulImageURL(d, 'memberImage');
            d.player.playerId = d.player.id;
          });
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updatePlayerClubMembership(mode: string, params: any): Observable<any> {
    let _params = {};
    _params['membership'] = params['membership'];
    let _playerId = params['playerId'];
    let _clubId = params['clubId'];
    let _mode;
    if (mode) _mode = mode;
    let _clubMembersURL = global.ServerUrls.listClubMembership + '/' + _clubId;
    if (_mode === 'approve') _clubMembersURL += global.ServerUrls.approveClubMembership + _playerId;
    else if (_mode === 'suspend')
      _clubMembersURL += global.ServerUrls.suspendClubMembership + _playerId;
    let request = new RemoteRequest(
      _clubMembersURL,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getHandicapSystemList() {
    let _params = {};
    let request = new RemoteRequest(
      global.ServerUrls.getHandicapSystemList,
      this.requestMethod.get,
      ContentType.XML
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerHandicapIndex(
    playerId: number,
    handicapSystem: string,
    forDate?: string
  ): Observable<any> {
    let params = {};
    let _hcpSys = handicapSystem;
    params['handicapSystem'] = _hcpSys;
    if (forDate) params['forDate'] = forDate;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerHcpIdx + '/' + playerId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getPlayerHandicapIndexInfo(
    playerId: number,
    handicapSystem: string,
    forDate?: string
  ): Observable<any> {
    let params = {};
    let _hcpSys = handicapSystem;
    params['handicapSystem'] = _hcpSys;
    if (forDate) params['forDate'] = forDate;
    let _url = global.ServerUrls.getPlayerHcpIdxInfo;
    let rePlayerId = /:playerId/gi;
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public syncPlayerHandicapIndex(playerId: number, handicapSystem: string): Observable<any> {
    let params = {};
    let _hcpSys = handicapSystem;
    params['handicapSystem'] = _hcpSys;
    params['playerId'] = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.syncHandicapIndex + '/' + playerId,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLatestCourseHandicap(
    playerId?: number,
    teeBox?: string,
    firstNineCourse?: number,
    secondNineCourse?: number
  ): Observable<any> {
    let hdrs = {};
    if (isPresent(playerId)) hdrs['Player-Id'] = playerId;
    let params = {};
    params['playerId'] = playerId;
    params['teeBox'] = teeBox;
    params['firstNine'] = firstNineCourse;
    params['secondNine'] = secondNineCourse;
    let _paramUrl = playerId + '/' + teeBox;
    let request = new RemoteRequest(
      global.ServerUrls.getLatestCourseHandicap + _paramUrl,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let courseHandicap: any = resp;
          return courseHandicap;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public checkLeagueCompetition(compId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueEclectic;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let eclectic: any = resp;
          return eclectic;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLeagueScorecards(compId?: number, seasonId?: number): Observable<any> {
    let hdrs = {};
    let params = {
      seasonId: seasonId,
    };
    let _url = global.ServerUrls.leagueScorecards;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let scorecards: LeagueScorecards = resp;
          scorecards.playerRounds.forEach((p: EclecticPlayerRound) => {
            JsonService.deriveFulImageURL(p, 'photo');
          });
          return scorecards;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLeagueLeaderboard(compId?: number, seasonId?: number): Observable<any> {
    let hdrs = {};
    let params = {
      seasonId: seasonId,
    };
    let _url = global.ServerUrls.leagueLeaderboard;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leagueLeaderboard: LeagueLeaderboard = resp;
          leagueLeaderboard.playerRounds.forEach((p: EclecticPlayerRound) => {
            JsonService.deriveFulImageURL(p, 'photo');
          });
          return leagueLeaderboard;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLeagueSeason(compId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.getLeagueSeason;
    let _compId = '/' + compId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeagueCompetition + _compId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leagueSeason: any = resp;
          return leagueSeason;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLeagueRounds(seasonId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueRounds;
    let _seasonId = '/' + seasonId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeague + _seasonId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leagueRounds: any = resp;
          return leagueRounds;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLeagueLowestLeaderboard(seasonId?: number): Observable<any> {
    let hdrs = {};
    let params = {};
    let _url = global.ServerUrls.leagueLowestGrossLeaderboard;
    let _seasonId = '/' + seasonId;
    let request = new RemoteRequest(
      global.ServerUrls.getLeague + _seasonId + _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leagueLowestLb: LowestAverageGrossLeaderboard = resp;
          leagueLowestLb.players.forEach((p: PlayerLowestAverageGross) => {
            JsonService.deriveFulImageURL(p, 'teeBoxImage');
            JsonService.deriveFulImageURL(p, 'imageUrl');
            JsonService.deriveFulImageURL(p, 'photo');
          });
          return leagueLowestLb;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getClubBookingList(
    clubId: number,
    fromDate?: string,
    toDate?: string,
    maxResults?: number,
    status?: string,
    courseId?: number
  ) {
    let _params = {};
    let _clubId = clubId ? '/' + clubId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (maxResults) _params['maxResults'] = maxResults;
    if (status) _params['status'] = status;
    if (courseId) _params['courseId'] = courseId;

    let request = new RemoteRequest(
      global.ServerUrls.getClubBookingList + _clubId + '/search',
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubBookingList: Array<TeeTimeBooking> = resp;
          clubBookingList.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
          });
          return {
            resp,
            clubBookingList,
          };
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubCaddySchedule(clubId: number, forDate?: string) {
    let _params = {};
    let _clubId = clubId ? '/' + clubId : '';
    if (forDate) _params['forDate'] = forDate;
    let request = new RemoteRequest(
      global.ServerUrls.displayCaddySchedule + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyScheduleList: Array<ClubCaddieSchedule> = resp;
          caddyScheduleList.forEach((csl: ClubCaddieSchedule) => {
            JsonService.deriveFullUrl(csl, 'caddieImage');
          });
          return caddyScheduleList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCaddyUnavailability(caddieId: number, fromDate?: string, toDate?: string) {
    let _params = {};
    let _caddieId = caddieId ? '/' + caddieId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;

    let request = new RemoteRequest(
      global.ServerUrls.listCaddyUnavailability + _caddieId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let caddyUnavailability: Unavailability = resp;
          return caddyUnavailability;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addCaddyUnavailability(
    caddieId: number,
    fromDate: string,
    toDate: string,
    remarks?: string
  ): Observable<any> {
    let params = {};
    let _caddieId = caddieId;
    params['fromDate'] = fromDate;
    params['toDate'] = toDate;
    let _remarks =
      'Set unavailability from ' +
      moment(fromDate).format('ddd, DD MMM YYYY') +
      ' to ' +
      moment(fromDate).format('ddd, DD MMM YYYY');
    params['remarks'] = remarks ? remarks : _remarks;
    let _paramUrl = '?' + 'fromDate=' + params['fromDate'] + '&toDate=' + params['toDate'];
    let request = new RemoteRequest(
      global.ServerUrls.addCaddyUnavailability + '/' + _caddieId + '/create' + _paramUrl,
      this.requestMethod.post,
      ContentType.JSON,
      params['remarks']
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public removeCaddyUnavailability(unavailabilityId: number): Observable<any> {
    let params = {};
    let _unavailabilityId = unavailabilityId;
    let request = new RemoteRequest(
      global.ServerUrls.addCaddyUnavailability + '/' + _unavailabilityId + '/delete',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerMaxBooking(clubId: number, playerId: number, teeOffDate?: string) {
    let _params = {};
    let _clubId = clubId ? '/' + clubId : '';
    let _playerId = playerId ? '/' + playerId : '';
    if (teeOffDate) _params['teeOffDate'] = teeOffDate;

    let request = new RemoteRequest(
      global.ServerUrls.getPlayerMaxBookingCount + _clubId + _playerId + '/booking-count',
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookingCount: BookingCount = resp;
          return bookingCount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addUserDocument(userId: number, params: any) {
    let _params;
    _params = params;

    let _url = global.ServerUrls.userProfiles.documents.add;
    let reUserId = /:userId/gi;
    _url = _url.replace(reUserId, userId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let user: UserAuthentication = resp;
          //??console.log("get list club vouchers issued : ", resp)
          return user;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBuggyUnavailability(buggyId: number, fromDate?: string, toDate?: string) {
    let _params = {};
    let _buggyId = buggyId ? '/' + buggyId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;

    let request = new RemoteRequest(
      global.ServerUrls.listBuggyUnavailability + _buggyId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let buggyUnavailability: Unavailability = resp;
          return buggyUnavailability;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addBuggyUnavailability(
    buggyId: number,
    fromDate: string,
    toDate: string,
    remarks?: string
  ): Observable<any> {
    let params = {};
    let _buggyId = buggyId;
    params['fromDate'] = fromDate;
    params['toDate'] = toDate;
    let _remarks =
      'Set unavailability from ' +
      moment(fromDate).format('ddd, DD MMM YYYY') +
      ' to ' +
      moment(fromDate).format('ddd, DD MMM YYYY');
    params['remarks'] = remarks ? remarks : _remarks;
    let _paramUrl = '?' + 'fromDate=' + params['fromDate'] + '&toDate=' + params['toDate'];
    let request = new RemoteRequest(
      global.ServerUrls.addBuggyUnavailability + '/' + _buggyId + '/create' + _paramUrl,
      this.requestMethod.post,
      ContentType.JSON,
      params['remarks']
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public removeBuggyUnavailability(unavailabilityId: number): Observable<any> {
    let params = {};
    let _unavailabilityId = unavailabilityId;
    let request = new RemoteRequest(
      global.ServerUrls.addBuggyUnavailability + '/' + _unavailabilityId + '/delete',
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPaymentMethodList() {
    let request = new RemoteRequest(
      global.ServerUrls.getPaymentMethodList,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let paymentMethodList: Array<PaymentMethod> = resp;
          return paymentMethodList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  setBookingCancelGuard(bookingId: number, resetCancelGuard: boolean = false) {
    let _bookingId;
    let _cancelGuard = '';
    if (resetCancelGuard) _cancelGuard = '?cancelGuard=' + 'false';
    if (bookingId) _bookingId = '/' + bookingId;
    let _bookingUrl =
      global.teeTimeBookingBase +
      _bookingId +
      global.ServerUrls.setBookingCancelGuard +
      _cancelGuard;
    let request = new RemoteRequest(
      _bookingUrl,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: TeeTimeBooking = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchBookingClub(
    clubId: number,
    fromDate?: string,
    toDate?: string,
    statusType?: string,
    statusList?: Array<string>,
    courseId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    bookingMedium?: string
  ) {
    let _params = {};
    let _clubId = clubId ? '/' + clubId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (statusType) _params['statusType'] = statusType;
    if (statusList) _params['statusList'] = statusList;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (bookingMedium) _params['bookingMedium'] = bookingMedium.toUpperCase();
    let request = new RemoteRequest(
      global.ServerUrls.searchBookingClub + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        fromDate: _params['fromDate'],
        toDate: _params['toDate'],
        statusType: _params['statusType'],
        statusList: _params['statusList'],
        courseId: _params['courseId'],
        pageNo: _params['pageNo'],
        pageSize: _params['pageSize'],
        search: _params['search'],
        bookingMedium: _params['bookingMedium'],
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubBookingList: PagedData<TeeTimeBooking> = resp;
          clubBookingList.items.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
          });
          return clubBookingList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public removeCardClubApplication(clubId: number, playerDiscountId: number): Observable<any> {
    let _params = {};
    let _clubId = clubId;
    if (playerDiscountId) _params['playerDiscountId'] = playerDiscountId;
    let request = new RemoteRequest(
      global.ServerUrls.removeCardClubApplication +
        '/' +
        _clubId +
        '?playerDiscountId=' +
        _params['playerDiscountId'],
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAppAttributes(initial: boolean = false) {
    let _params = {};
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (!initial)
      _url = global.MygolfServer + '/document/assets/app-attributes.json' + '?v=' + _randomizer;
    else _url = 'http://app.mygolf2u.com/settings' + '/app-attributes.json' + '?v=' + _randomizer;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPartnerAttributes(initial: boolean = false) {
    let _params = {};
    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url;
    if (!initial)
      _url = global.MygolfServer + '/document/assets/partner-attributes.json' + '?v=' + _randomizer;
    else
      _url = 'http://app.mygolf2u.com/settings' + '/partner-attributes.json' + '?v=' + _randomizer;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchBookingPlayer(
    playerId: number,
    clubId?: number,
    fromDate?: string,
    toDate?: string,
    statusType?: string,
    statusList?: Array<string>,
    courseId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    descendingByDate?: boolean
  ) {
    let _params = {};
    let _playerId = playerId ? '/' + playerId : '';
    if (clubId) _params['clubId'] = clubId;
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (statusType) _params['statusType'] = statusType;
    if (statusList) _params['statusList'] = statusList;
    if (courseId) _params['courseId'] = courseId;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (descendingByDate) _params['descendingByDate'] = descendingByDate;
    let request = new RemoteRequest(
      global.ServerUrls.searchBookingPlayer + _playerId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: _params['clubId'],
        fromDate: _params['fromDate'],
        toDate: _params['toDate'],
        statusType: _params['statusType'],
        statusList: _params['statusList'],
        courseId: _params['courseId'],
        pageNo: _params['pageNo'],
        pageSize: _params['pageSize'],
        search: _params['search'],
        descendingByDate: _params['descendingByDate'],
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerBookingList: PagedData<TeeTimeBooking> = resp;
          playerBookingList.items.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
            JsonService.deriveFullUrl(tb.clubData, 'clubImage');
            JsonService.deriveFullUrl(tb.clubData, 'clubLogo');
            JsonService.deriveFullUrl(tb.clubData, 'clubThumbnail');
          });
          return playerBookingList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public refundRedeemForPlayer(
    clubId: number,
    playerId: number,
    startDate: string,
    endDate?: string,
    include: string = 'both'
  ) {
    let _params = {};
    let _clubId = clubId;
    if (playerId) _params['playerId'] = playerId;
    if (startDate) _params['startDate'] = startDate;
    if (endDate) _params['endDate'] = endDate;
    if (include) _params['include'] = include;
    let request = new RemoteRequest(
      global.ServerUrls.refundRedeemForPlayer + '/' + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public refundRedeemForClub(
    clubId: number,
    startDate: string,
    endDate?: string,
    include: string = 'both'
  ) {
    let _params = {};
    let _clubId = clubId;
    if (startDate) _params['startDate'] = startDate;
    if (endDate) _params['endDate'] = endDate;
    if (include) _params['include'] = include;
    let request = new RemoteRequest(
      global.ServerUrls.refundRedeemForClub + '/' + _clubId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  undoRefundBooking(bookingId: number, refundInstanceId: number) {
    let _bookingId;
    let _refundInstanceId;
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (refundInstanceId) _params['refundInstanceId'] = refundInstanceId;
    let _bookingUrl = global.ServerUrls.undoRefundBooking;
    let request = new RemoteRequest(
      _bookingUrl,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: TeeTimeBooking = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  undoCancelBooking(bookingId: number) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    let _bookingUrl = global.ServerUrls.undoCancelBooking;
    let request = new RemoteRequest(
      _bookingUrl,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: TeeTimeBooking = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateNinesBooking(bookingId: number, ninesPlayed: number) {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (ninesPlayed) _params['ninesPlayed'] = ninesPlayed;
    let _bookingUrl = global.ServerUrls.updateNinesBooking;
    let request = new RemoteRequest(
      _bookingUrl,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: TeeTimeBooking = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getAppRoleAccess() {
    let _params = {};

    let _randomizer = Math.floor(Math.random() * 7777) + 1;
    let _url = 'assets/app-role-access.json' + '?v=' + _randomizer;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public checkUsernameAvailabilty(userName: string) {
    let _params = {};
    if (userName) _params['userName'] = userName;
    let request = new RemoteRequest(
      global.ServerUrls.checkUsernameAvailability,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * @param playerId
   * Gets all the club membership details ordered by club names
   * @returns {Observable<R>}
   */
  public getPlayerMemberships(playerId: number): Observable<Array<ClubMembership>> {
    let _playerId;
    if (playerId) _playerId = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.playerMemberships,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      null,
      {
        'Player-Id': _playerId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let memberships: Array<ClubMembership> = resp;
          memberships.forEach((cm: ClubMembership) => {
            if (cm.club && cm.club.clubImage) JsonService.deriveFullUrl(cm.club, 'clubImage');
            JsonService.deriveFullUrl(cm.club, 'clubLogo');
            JsonService.deriveFullUrl(cm.club, 'clubThumbnail');
            JsonService.deriveFulImageURL(cm, 'memberImage');
          });
          return memberships;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubMembershipsForPlayer(playerId: number) {
    let _playerId;
    if (playerId) _playerId = playerId;
    let re = /:playerId/gi;
    let _url = global.ServerUrls.clubMemberships.listForPlayer;
    _url = _url.replace(re, _playerId);

    let request = new RemoteRequest(_url, this.requestMethod.get);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let memberships: Array<any> = resp;
          memberships.forEach((cm: ClubMembershipExtended) => {
            JsonService.deriveFulImageURL(cm, 'memberImage');
            JsonService.deriveFulImageURL(cm.club, 'clubImage');
            JsonService.deriveFulImageURL(cm.club, 'clubLogo');
            JsonService.deriveFulImageURL(cm.club, 'clubThumbnail');
          });
          return memberships;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerClubTransactions(params: any) {
    let _url = global.ServerUrls.playerAccounts.listTransations;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubAccountTransactionPage: PlayerClubAccountTransactionPage = resp;

          return playerClubAccountTransactionPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerClubStatements(params: any) {
    let _playerId;

    let _url = global.ServerUrls.playerAccounts.listStatements;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubAccountStatementPage: PlayerClubAccountStatementPage = resp;

          return playerClubAccountStatementPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateSlotBuggyCaddieSettings(slotDayId: number, slotNo: number, params: any) {
    let _params = {};
    if (params) _params = params;
    if (slotDayId) _params['slotDayId'] = slotDayId;
    if (slotNo) _params['slotNo'] = slotNo;
    let _url = global.ServerUrls.teeTime.updateSlotBuggyCaddieSettings;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  createUpdateUsername(userId: number, userName: string) {
    let _userId;
    let _params = {};
    if (userId) _userId = userId;
    if (userName) _params['userName'] = userName;
    let _updateUsernameURL =
      global.ServerUrls.profileUsers + '/' + _userId + '/' + global.ServerUrls.createUpdateUsername;

    let request = new RemoteRequest(
      _updateUsernameURL,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: TeeTimeBooking = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  transferPlayerVoucher(params: any) {
    let _params = {};
    if (params) _params = params;
    let _url = global.ServerUrls.transferPlayerVoucher;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  userProfileUpdateDefaultAddress(userId: number, addressName: string, addressData: AddressData) {
    let _addressName;
    let _userId;
    let _params = {};
    if (_addressName) _addressName = addressName;
    if (userId) _userId = userId;
    if (addressData) _params = addressData;
    let _updateAddressURL =
      global.ServerUrls.profileUsers +
      '/' +
      _userId +
      global.ServerUrls.userProfiles.updateDefaultAddress;

    if (1) return;
    let request = new RemoteRequest(
      _updateAddressURL,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: PlayerData = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  userProfileUpdateAddress(
    userId: number,
    userAddressData: UserAddress,
    addressName: string,
    addressData: AddressData,
    setDefault?: boolean
  ) {
    let _addressName = '';
    let _userId;
    let _setDefault = setDefault;
    let _params = {};
    if (addressName) _addressName = addressName;
    if (userId) _userId = userId;
    if (addressData) _params = addressData;
    let _params2 = { setDefault: _setDefault, addressName: _addressName };
    _params = { ..._params, ..._params2 };

    let _updateAddressURL =
      global.ServerUrls.profileUsers + '/' + _userId + global.ServerUrls.userProfiles.saveAddress;

    let request = new RemoteRequest(
      _updateAddressURL,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  userProfileDeleteAddress(userId: number, addressName: string) {
    let _addressName;
    let _userId = userId;
    let _params = {};
    if (addressName) _addressName = addressName;
    _params = {
      addressName: _addressName,
    };
    let _updateAddressURL =
      global.ServerUrls.profileUsers + '/' + _userId + global.ServerUrls.userProfiles.deleteAddress;

    let request = new RemoteRequest(
      _updateAddressURL,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getPlayerClubStatementsDetail(params: any) {
    let _statementId;
    if (params) _statementId = params['statementId'];
    let re = /:statementid/gi;
    let _url = global.ServerUrls.playerAccounts.getStatementById;
    _url = _url.replace(re, _statementId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubAccountStatement: PlayerClubAccountStatement = resp;

          return playerClubAccountStatement;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  transferAndApplyPlayerVoucher(params: any) {
    let _params = {};
    if (params) _params = params;
    let _url = global.ServerUrls.transferAndApplyVoucher;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public registerNewPlayer(
    firstName: string,
    lastName: string,
    gender: string,
    email: string,
    phone: string,
    handicap: number,
    teeoff: string,
    countryId?: string,
    nationalityId?: string,
    clubId?: number
  ): Observable<PlayerInfo> {
    let request = new RemoteRequest(
      global.ServerUrls.registerPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        firstName: firstName,
        lastName: lastName,
        gender: gender,
        email: email,
        teeoff: teeoff,
        phone: phone,
        handicap: handicap,
        country: countryId,
        nationality: nationalityId,
        addedByClub: clubId,
      }
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let player: PlayerInfo = resp;
          return player;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  createUpdatePrimaryMembership(clubId: number, playerId: number, params?: any, image?: any) {
    let _params = {};
    let _clubId = clubId;
    let _playerId = playerId;
    if (params) _params = params;
    if (_playerId) _params['playerId'] = _playerId;

    const _formData: FormData = new FormData();

    for (let p in params) {
      _formData.append(p, params[p]);
    }
    if (image) _formData.append('memberImage', image);
    let re = /:clubId/gi;
    let _url = global.ServerUrls.clubMemberships.createUpdatePrimary;
    _url = _url.replace(re, _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.MULTIPART_FORM,
      // ContentType.URL_ENCODED_FORM_DATA,
      _formData
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteClubMembership(clubId: number, membershipId: number, params?: any) {
    let _params = {};
    let _clubId = clubId;
    let _membershipId = membershipId;
    if (params) _params = params;
    if (_membershipId) _params['membershipId'] = _membershipId;

    let reClub = /:clubId/gi;
    let reMembership = /:membershipId/gi;
    let _url = global.ServerUrls.clubMemberships.deleteMembership;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(reMembership, _membershipId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getSpecificClubMembership(clubId: number, membershipId: number, params?: any) {
    let _params = {};
    let _clubId = clubId;
    let _membershipId = membershipId;
    if (params) _params = params;
    if (_membershipId) _params['membershipId'] = _membershipId;

    let reClub = /:clubId/gi;
    let reMembership = /:membershipId/gi;
    let _url = global.ServerUrls.clubMemberships.getSpecificClubMembership;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(reMembership, _membershipId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;

          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  userProfileSetDefaultAddress(userId: number, addressName: string) {
    let _addressName;
    let _params = {};
    let _userId;
    if (userId) _userId = userId;
    if (addressName) _params['addressName'] = addressName;
    let _setDefaultAddressURL =
      global.ServerUrls.profileUsers +
      '/' +
      _userId +
      global.ServerUrls.userProfiles.setDefaultAddress;

    let request = new RemoteRequest(
      _setDefaultAddressURL,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: PlayerData = resp;
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerClubAccount(params: any) {
    let _statementId;
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getClubAccount;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubAccount: PlayerClubAccount = resp;

          return playerClubAccount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListClubMembershipTypes(params: any) {
    let _statementId;
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubMemberships.listClubMembershipTypes;
    _url = _url.replace(reClubId, _params['clubId']);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubMembershipTypes: Array<ClubMembershipType> = resp;

          return clubMembershipTypes;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubMembershipOptions(clubId: number) {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubMemberships.clubMembershipOptions;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubMembershipOption: ClubMembershipOption = resp;

          return clubMembershipOption;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerWalletBalance(
    clubId: number,
    playerId: number
  ): Observable<PlayerClubWalletBalance> {
    let _playerId;
    let _clubId;
    if (playerId) _playerId = playerId;
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;

    let _url = global.ServerUrls.playerClubWallet.getWalletBalance;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerWallet: PlayerClubWalletBalance = resp;
          return playerWallet;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubWalletTransactions(
    clubId: number,
    params
  ): Observable<PlayerClubWalletTransactionPage> {
    let _playerId;
    let _clubId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getWalletTransactions;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerWalletTransactionPage: PlayerClubWalletTransactionPage = resp;
          return playerWalletTransactionPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubWalletTopUps(clubId: number, params): Observable<PlayerClubWalletTopupPage> {
    let _playerId;
    let _clubId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getWalletTopups;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubWalletTopup: PlayerClubWalletTopupPage = resp;
          return playerClubWalletTopup;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addClubPlayerTopup(clubId: number, playerId?: number, params?: any): Observable<any> {
    let _clubId;
    let _playerId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;

    let _url = global.ServerUrls.playerClubWallet.addClubTopup;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerWalletTopup: any = resp;
          return playerWalletTopup;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateClubPlayerTopup(
    clubId: number,
    playerId: number,
    topupId: number,
    params?: any
  ): Observable<any> {
    let _clubId;
    let _playerId;
    let _topupId;
    let _params;

    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;
    if (topupId) _topupId = topupId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    let reTopup = /:topupId/gi;

    let _url = global.ServerUrls.playerClubWallet.updateTopupAttribute;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reTopup, _topupId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerWalletTopup: any = resp;
          return playerWalletTopup;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deleteClubPlayerTopup(clubId: number, playerId: number, topupId: number): Observable<any> {
    let _clubId = clubId;
    let _playerId;
    let _topupId;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;
    if (topupId) _topupId = topupId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    let reTopup = /:topupId/gi;

    let _url = global.ServerUrls.playerClubWallet.deleteClubTopup;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reTopup, _topupId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getUserDetailsById(userId: number): Observable<UserAuthentication> {
    let _userId;
    let _params;
    if (userId) _userId = userId;

    let reUser = /:userId/gi;

    let _url = global.userProfile + global.ServerUrls.userProfiles.getUserDetails;
    _url = _url.replace(reUser, _userId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let userDetails: UserAuthentication = resp;
          return userDetails;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getSlotPrices(params: any): Observable<Array<TeeTimePrice>> {
    let _params;
    if (params) _params = params;

    let _url = global.ServerUrls.teeTime.getSlotPrices;

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let slotPrices: Array<TeeTimePrice> = resp;
          return slotPrices;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPricingComponents(
    clubId: number,
    params?: any
  ): Observable<Array<TeeTimePriceComponent>> {
    let _params;
    let _clubId;
    if (params) _params = params;
    if (params && params['clubId']) _clubId = params['clubId'];

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.teeTime.getPricingComponents;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let pricingComponents: Array<TeeTimePriceComponent> = resp;
          return pricingComponents;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addUpdateAdditionalItems(bookingId: number, params?: any): Observable<TeeTimeBooking> {
    let _bookingId;
    let _params;
    if (params) _params = params;
    if (bookingId) _bookingId = bookingId;
    let reBooking = /:bookingId/gi;

    let _url = global.ServerUrls.teeTime.addUpdateAdditionalItems;
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(_url, this.requestMethod.post, ContentType.XML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeBooking: TeeTimeBooking = resp;
          return teeTimeBooking;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deleteAdditionalItems(bookingId: number, itemIds: Array<number>): Observable<any> {
    let _bookingId;
    let _itemIds;
    if (bookingId) _bookingId = bookingId;
    if (itemIds) _itemIds = itemIds;

    let reBooking = /:bookingId/gi;

    let _url = global.ServerUrls.teeTime.deleteAdditionalItems;
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        itemIds: _itemIds,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getExpenditureTypes(clubId: number, search: string): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (search) _params['search'] = search;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getExpenditureTypes;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let expenditureTypes: Array<any> = resp;
          return expenditureTypes;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubWalletBalance(
    clubId: number,
    params: any
  ): Observable<PlayerClubWalletBalancePage> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (params) _params = params;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.playerClubWallet.getClubWalletBalance;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let walletBalances: PlayerClubWalletBalancePage = resp;
          walletBalances.items.forEach((item: PlayerClubWalletBalance) => {
            JsonService.deriveFullUrl(item.player, 'image');
            JsonService.deriveFullUrl(item.player, 'profile');
          });
          return walletBalances;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deductWalletBalance(
    clubId: number,
    playerId: number,
    params?: any
  ): Observable<TeeTimeBooking> {
    let _clubId;
    let _playerId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (playerId) _playerId = playerId;

    let reClub = /:clubId/gi;
    let rePlayer = /:playerId/gi;
    let _url = global.ServerUrls.playerClubWallet.deductWalletBalance;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(rePlayer, _playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeBooking: TeeTimeBooking = resp;
          return teeTimeBooking;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public revertWalletBalance(params): Observable<any> {
    let _params = {};
    if (params) _params = params;

    let request = new RemoteRequest(
      global.ServerUrls.playerClubWallet.revertWalletBalance,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingBillPrint(
    bookingId: number,
    format?: string,
    bookingPlayerId?: number
  ): Observable<any> {
    let _bookingId = bookingId;
    let _bookingPlayerId = bookingPlayerId;
    let _format = format;

    let reBooking = /:bookingId/gi;
    let _params = {};
    if (format) _params['format'] = _format;
    if (bookingPlayerId) _params['bookingPlayerId'] = _bookingPlayerId;
    let _url = global.ServerUrls.generateBookingBill;
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getDetailedItemizedBill(bookingId: number, format?: string): Observable<any> {
    let _bookingId = bookingId;
    let _format = format;

    let reBooking = /:bookingId/gi;
    let _params = {};
    if (format) _params['format'] = _format;

    let _url = global.ServerUrls.generateItemizedBill;
    _url = _url.replace(reBooking, _bookingId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getSummaryDailyReportCashier(params: any): Observable<any> {
    let _params = params;
    let _url = global.ServerUrls.getSummaryDailyReportCashier;

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getSummaryDailyReport(clubId: number, params: any): Observable<any> {
    let _params = params;
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.getSummaryDailyReport;
    _url = _url.replace(reClubId, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public downloadSummaryDailyReportCashier(params: any): Observable<any> {
    let _params = params;
    let _url = global.ServerUrls.downloadSummaryDailyReportCashier;

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateBookingMedium(params: any): Observable<any> {
    let _params;
    if (params) _params = params;

    let _url = global.ServerUrls.updateBookingMedium;
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubListLite(clubId: number, params?: any): Observable<ClubDataLite> {
    let _params;
    _params = {
      activeOnly: true,
      pageSize: 1000,
    };
    let _url = global.ServerUrls.lite.clubListOpen;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubLitePage: ClubDataLitePage = resp;
          let _clubLite: ClubDataLite;

          if (clubLitePage && clubLitePage.totalItems > 0) {
            _clubLite = clubLitePage.items.find((club: ClubDataLite) => {
              return club.clubId == clubId;
            });
          }
          return _clubLite;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubInfoLite(clubId: number): Observable<ClubDataLite> {
    let _clubId = clubId;
    let reClub = /:clubId/gi;
    let _url = global.ServerUrls.lite.getClubInfo;
    _url = _url.replace(reClub, _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _clubLite: ClubDataLite = resp;
          return _clubLite;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubOutletList(clubId: number, params?: any): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (params) _params = params;
    let reClub = /:clubId/gi;
    let _url = global.ServerUrls.outlet.getClubOutletList;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: ClubOutletPage = resp;
          let clubOutletList: Array<ClubOutlet> = [];

          _resp.items.forEach((pack: any, index: number) => {
            JsonService.deriveFullImageUrlArrayObject(pack.images);
          });

          if (_resp && _resp.totalItems > 0) clubOutletList = _resp.items;

          return clubOutletList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubLoggedInOutletsList(clubId: number, params?: any): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    if (params) _params = params;
    let reClub = /:clubId/gi;
    let _url = global.ServerUrls.outlet.getLoggedInOutletList;
    _url = _url.replace(reClub, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubOutletList: Array<ClubOutlet> = resp;
          return clubOutletList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getListClubMemberships(clubId: number, params?: any) {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    let _status;
    if (params) _params = params;

    let _clubMembersURL = global.ServerUrls.clubMemberships.listClubMemberships;
    let reClub = /:clubId/gi;
    _clubMembersURL = _clubMembersURL.replace(reClub, _clubId);
    let request = new RemoteRequest(
      _clubMembersURL,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: ClubMembershipPage = resp;
          data.items.forEach((c: ClubMembership) => {
            JsonService.deriveFulImageURL(c.player, 'profile');
            JsonService.deriveFulImageURL(c.player, 'image');
            JsonService.deriveFulImageURL(c, 'memberImage');
            c.player.playerId = c.player.id;
          });
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public suspendClubmembership(
    clubId: number,
    membershipId: number,
    params?: any
  ): Observable<any> {
    let _clubId;
    let _membershipId;
    let _params;
    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (membershipId) _membershipId = membershipId;
    let reClub = /:clubId/gi;
    let reMembership = /:membershipId/gi;

    let _url = global.ServerUrls.clubMemberships.suspendMulti;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(reMembership, _membershipId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public userRequestAccountDeletion() {
    let _url = global.ServerUrls.userAccount.requestAccountDeletion;
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public userProcessDeleteRequest() {
    let _url = global.ServerUrls.userAccount.processDeleteRequests;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public userUndoDeleteRequest() {
    let _url = global.ServerUrls.userAccount.undoDeleteRequest;
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public userListRequestAccountDeletion(params) {
    let _url = global.ServerUrls.userAccount.listAccountDeletionRequests;
    let _params = params;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: PlayerDataPage = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getPlayerInsurances(playerId: number, params?: any) {
    let _url = global.ServerUrls.playerInsurance.listInsurances;

    let rePlayer = /:playerId/gi;
    _url = _url.replace(rePlayer, playerId);
    let _params = params;

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<PlayerInsurance> = resp;

          data.forEach(d => {
            JsonService.deriveFulImageURL(d, 'insuranceDocument');
          });

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getAllPlayersInsurances(params?: any) {
    let _url = global.ServerUrls.playerInsurance.listAll;
    let _params = params;

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: PlayerDataPage = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addPlayerInsurance(playerId: number, params: any): Observable<any> {
    let _playerId = playerId;
    let _params = params;
    let _url = global.ServerUrls.playerInsurance.addInsurance;
    let rePlayer = /:playerId/gi;
    _url = _url.replace(rePlayer, _playerId);

    if (this.platform.is('capacitor')) {
      return from(
        this.ftService.uploadFile(
          _params['insuranceDocument'],
          _url,
          ContentType.WILDCARD_IMAGE,
          _params
        )
      );
    } else {
      let request = new RemoteRequest(
        _url,
        this.requestMethod.post,
        ContentType.URL_ENCODED_FORM_DATA,
        _params
      );
      return this.http
        .execute(request)
        .pipe(map((resp: any) => resp))
        .pipe(catchError(this.http.handleError));
    }
  }

  updatePlayerInsurance(playerId: number, insuranceId: number, params: any): Observable<any> {
    let _playerId = playerId;
    let _insuranceId = insuranceId;
    let _params = params;
    let _url = global.ServerUrls.playerInsurance.updateDeleteInsurance;
    let rePlayer = /:playerId/gi;
    let reInsurance = /:insuranceId/gi;
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reInsurance, _insuranceId);
    if (this.platform.is('capacitor')) {
      return from(
        this.ftService.uploadFile(
          _params['insuranceDocument'],
          _url,
          ContentType.WILDCARD_IMAGE,
          _params
        )
      );
    } else {
      let request = new RemoteRequest(
        _url,
        this.requestMethod.post,
        ContentType.URL_ENCODED_FORM_DATA,
        _params
      );
      return this.http
        .execute(request)
        .pipe(map((resp: any) => resp))
        .pipe(catchError(this.http.handleError));
    }
  }

  deletePlayerInsurance(playerId: number, insuranceId: number, params?: any) {
    let _playerId = playerId;
    let _insuranceId = insuranceId;
    let _params = params;
    let _url = global.ServerUrls.playerInsurance.updateDeleteInsurance;
    let rePlayer = /:playerId/gi;
    let reInsurance = /:insuranceId/gi;
    _url = _url.replace(rePlayer, _playerId);
    _url = _url.replace(reInsurance, _insuranceId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  public getPartnerDetails(partnerId: string) {
    let _partnerId = partnerId;
    let _url = global.ServerUrls.partnerDiscountCompany.getDetails;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(rePartnerId, _partnerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let partner: DiscountCompany = resp;
          JsonService.deriveFulImageURL(partner, 'partnerImage');
          return partner;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPartnerList(params: any) {
    let _params = params;
    let request = new RemoteRequest(
      global.ServerUrls.partnerDiscountCompany.list,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let discountCompanies: DiscountCompanyPage = resp;
          if (discountCompanies && discountCompanies.totalItems > 0)
            discountCompanies.items.forEach((dc: DiscountCompany) => {
              JsonService.deriveFulImageURL(dc, 'partnerImage');
            });

          return discountCompanies;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getFilteredClubMemberships(clubId: number, params?: any) {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;
    let _status;
    if (params) _params = params;

    let _clubMembersURL = global.ServerUrls.clubMemberships.listClubMemberships;
    let reClub = /:clubId/gi;
    _clubMembersURL = _clubMembersURL.replace(reClub, _clubId);
    let request = new RemoteRequest(
      _clubMembersURL,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: ClubMembershipPage = resp;
          data.items.forEach((c: ClubMembership) => {
            JsonService.deriveFulImageURL(c.player, 'profile');
            JsonService.deriveFulImageURL(c.player, 'image');
            c.player.playerId = c.player.id;
            JsonService.deriveFulImageURL(c, 'memberImage');
          });

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBulkPlayerMemberships(playerId: number): Observable<Array<ClubMembership>> {
    let _playerId;
    if (playerId) _playerId = playerId;
    let request = new RemoteRequest(
      global.ServerUrls.playerMemberships,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      null,
      {
        'Player-Id': _playerId,
      }
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let memberships: Array<ClubMembership> = resp;
          memberships.forEach((cm: ClubMembership) => {
            if (cm.club && cm.club.clubImage) JsonService.deriveFullUrl(cm.club, 'clubImage');
            JsonService.deriveFulImageURL(cm, 'memberImage');
          });
          return memberships;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerMaxChargeableAmount(params: any) {
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getMaxChargeableClub;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public bookingChargeToClub(
    bookingId: number,
    playerId: number,
    amount: number,
    bypassWallet?: boolean,
    remarks?: string
  ): Observable<any> {
    let _params = {};
    if (bookingId) _params['bookingId'] = bookingId;
    if (playerId) _params['playerId'] = playerId;
    if (amount) _params['amount'] = amount;
    if (bypassWallet) _params['bypassWallet'] = bypassWallet;
    if (remarks) _params['remarks'] = remarks;
    let request = new RemoteRequest(
      global.ServerUrls.playerAccounts.bookingChargeToClub,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateCreditLimit(clubId: number, playerId: number, params: any): Observable<any> {
    let _params = {};

    if (params) _params = params;
    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.updateCreditLimit;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.put,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public createPlayerClubAccount(params: any) {
    let _statementId;
    let _params = {};
    _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getClubAccount;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubAccount: PlayerClubAccount = resp;

          return playerClubAccount;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateClubPaymentMethod(billId: number, method: string) {
    let _billId;
    let _params = {};

    if (billId) _billId = billId;
    if (method) _params['paymentMethod'] = method;
    let reBillId = /:billId/gi;
    let _url = global.ServerUrls.updateClubPaymentMethod;
    _url = _url.replace(reBillId, _billId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.put,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBillDetails(billId: number) {
    let reBillId = /:billId/gi;
    let _url = global.ServerUrls.getBillDetails;
    _url = _url.replace(reBillId, billId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let billDetails: Bill = resp;

          return billDetails;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listPartnerApplication(params) {
    let _params = params;

    let _url = global.ServerUrls.partnerDiscountCompany.listApplications;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let partnerApplications: PartnerProgramMembershipApplicationPage = resp;

          if (partnerApplications && partnerApplications.items) {
            if (partnerApplications.items.length > 0) {
              partnerApplications.items.forEach(ppma => {
                if (
                  ppma.partnerProgram &&
                  ppma.partnerProgram.discountCompany &&
                  ppma.partnerProgram.discountCompany.partnerImage
                )
                  JsonService.deriveFulImageURL(
                    ppma.partnerProgram.discountCompany,
                    'partnerImage'
                  );
              });
            }
          }
          return partnerApplications;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public createProgramApplication(
    partnerId: string,
    programId: number,
    playerId: number
  ): Observable<any> {
    let _params = {
      playerId: playerId,
    };
    let rePartnerId = /:partnerId/gi;
    let reProgramId = /:programId/gi;
    let _url = global.ServerUrls.partnerDiscountCompany.createApplication;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reProgramId, programId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateProgramApplication(partnerId: string, programId: number, params): Observable<any> {
    let _params = params;
    let rePartnerId = /:partnerId/gi;
    let reProgramId = /:programId/gi;
    let _url = global.ServerUrls.partnerDiscountCompany.updateApplication;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reProgramId, programId);

    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateProgramMembership(
    partnerId: string,
    playerMembershipId: number,
    params
  ): Observable<any> {
    let _params = params;
    let rePartnerId = /:partnerId/gi;
    let rePlayerMembershipId = /:playerMembershipId/gi;
    let _url = global.ServerUrls.partnerDiscountCompany.updateMembership;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(rePlayerMembershipId, playerMembershipId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listAllPartnerMemberships(partnerId: string, params) {
    let _params = params;
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.listAllMembers;
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerProgramPage: PlayerDiscountProgramPage = resp;

          if (playerProgramPage && playerProgramPage.items) {
            if (playerProgramPage.items.length > 0) {
              playerProgramPage.items.forEach(ppma => {
                if (
                  ppma.discountProgram &&
                  ppma.discountProgram.discountCompany &&
                  ppma.discountProgram.discountCompany.partnerImage
                )
                  JsonService.deriveFulImageURL(
                    ppma.discountProgram.discountCompany,
                    'partnerImage'
                  );
                JsonService.deriveFulImageURL(ppma.player, 'profile');
                JsonService.deriveFulImageURL(ppma.player, 'image');
                if (ppma && ppma.document) JsonService.deriveFulImageURL(ppma, 'document');
              });
            }
          }
          return playerProgramPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public listProgramMemberships(partnerId: string, programId: string, params) {
    let _params = params;
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;
    let _programId = programId;
    let reprogramId = /:programId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.listProgramMembers;
    _url = _url.replace(rePartnerId, partnerId);
    _url = _url.replace(reprogramId, programId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerProgramPage: PlayerDiscountProgramPage = resp;

          if (playerProgramPage && playerProgramPage.items) {
            if (playerProgramPage.items.length > 0) {
              playerProgramPage.items.forEach(ppma => {
                if (
                  ppma.discountProgram &&
                  ppma.discountProgram.discountCompany &&
                  ppma.discountProgram.discountCompany.partnerImage
                )
                  JsonService.deriveFulImageURL(
                    ppma.discountProgram.discountCompany,
                    'partnerImage'
                  );
                JsonService.deriveFulImageURL(ppma.player, 'profile');
                JsonService.deriveFulImageURL(ppma.player, 'image');
              });
            }
          }
          return playerProgramPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubAccountsList(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.playerAccounts.listInClub;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubPlayerAccountsPage: PlayerClubAccountPage = resp;

          return clubPlayerAccountsPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public playerPaymentToClub(clubId: number, playerId: number, params: any): Observable<any> {
    let _params = params;
    let _clubId = clubId;
    let _playerId = playerId;
    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.paymentToClub;
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(rePlayerId, _playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateProgramAppNumbers(
    partnerId: string,
    programId: string,
    applicationId: number,
    params?: any
  ): Observable<any> {
    let _partnerId;
    let _programId;
    let _applicationId;
    let _params;

    if (params) _params = params;
    if (partnerId) _partnerId = partnerId;
    if (programId) _programId = programId;
    if (applicationId) _applicationId = applicationId;

    let rePartner = /:partnerId/gi;
    let reProgram = /:programId/gi;
    let reApplication = /:applicationId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.updateNumbers;
    _url = _url.replace(rePartner, _partnerId);
    _url = _url.replace(reProgram, _programId);
    _url = _url.replace(reApplication, _applicationId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public generateBookingReports(url: string, params: any): Observable<any> {
    let _params = params;
    let _clubId = params['clubId'];
    let reClubId = /:clubId/gi;
    let _url = global.MygolfServer + url;
    _url = _url.replace(reClubId, _clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getPricingPlansList(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.teeTime.listPricingPlans;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let pricingPlans: Array<TeeTimePricingPlan> = resp;

          return pricingPlans;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getFilteredTeeSlots(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.teeTime.searchSlots;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let teeTimeSlotDisplayPage: TeeTimeSlotDisplayPage = resp;

          return teeTimeSlotDisplayPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateTeeSlots(clubId: number, search: any, update: any): Observable<any> {
    let _clubId = clubId;
    let _params = {};
    if (search.slotsIn) _params['search.slotsIn'] = search.slotsIn;
    if (search.teeOffTimeFrom) _params['search.teeOffTimeFrom'] = search.teeOffTimeFrom;
    if (search.teeOffTimeTo) _params['search.teeOffTimeTo'] = search.teeOffTimeTo;
    if (search.weekDays) _params['search.weekDays'] = search.weekDays;
    if (search.specialDays) _params['search.specialDays'] = search.specialDays;
    if (search.booked) _params['search.booked'] = search.booked;
    if (search.allowWalking) _params['search.allowWalking'] = search.allowWalking;
    if (search.availableForBooking)
      _params['search.availableForBooking'] = search.availableForBooking;
    if (search.allowNineHole) _params['search.allowNineHole'] = search.allowNineHole;
    if (search.allowEighteenHole) _params['search.allowEighteenHole'] = search.allowEighteenHole;
    if (search.membersOnly) _params['search.membersOnly'] = search.membersOnly;
    if (search.maxPlayers) _params['search.maxPlayers'] = search.maxPlayers;
    if (search.minPlayers) _params['search.minPlayers'] = search.minPlayers;
    if (search.maxPlayersPerBuggy) _params['search.maxPlayersPerBuggy'] = search.maxPlayersPerBuggy;
    if (search.maxPlayersPerCaddie)
      _params['search.maxPlayersPerCaddie'] = search.maxPlayersPerCaddie;
    if (search.regularPricingPlan) _params['search.regularPricingPlan'] = search.regularPricingPlan;
    if (search.promotionalPricingPlan)
      _params['search.promotionalPricingPlan'] = search.promotionalPricingPlan;
    if (search.jumboPricingPlan) _params['search.jumboPricingPlan'] = search.jumboPricingPlan;
    if (search.courses) _params['search.courses'] = search.courses;
    if (search.fromDate) _params['search.fromDate'] = search.fromDate;
    if (search.toDate) _params['search.toDate'] = search.toDate;
    if (update.allowWalking) _params['update.allowWalking'] = update.allowWalking;
    if (update.availableForBooking)
      _params['update.availableForBooking'] = update.availableForBooking;
    if (update.reasonForBlocking) _params['update.reasonForBlocking'] = update.reasonForBlocking;
    if (update.allowNineHole) _params['update.allowNineHole'] = update.allowNineHole;
    if (update.allowEighteenHole) _params['update.allowEighteenHole'] = update.allowEighteenHole;
    if (update.membersOnly) _params['update.membersOnly'] = update.membersOnly;
    if (update.maxPlayers) _params['update.maxPlayers'] = update.maxPlayers;
    if (update.minPlayers) _params['update.minPlayers'] = update.minPlayers;
    if (update.maxPlayersPerBuggy) _params['update.maxPlayersPerBuggy'] = update.maxPlayersPerBuggy;
    if (update.maxPlayersPerCaddie)
      _params['update.maxPlayersPerCaddie'] = update.maxPlayersPerCaddie;
    if (update.maxPlayersPerBuggyJumbo)
      _params['update.maxPlayersPerBuggyJumbo'] = update.maxPlayersPerBuggyJumbo;
    if (update.maxPlayersPerCaddieJumbo)
      _params['update.maxPlayersPerCaddieJumbo'] = update.maxPlayersPerCaddieJumbo;
    if (update.regularPricingPlan) _params['update.regularPricingPlan'] = update.regularPricingPlan;
    if (update.clearPromotion) _params['update.clearPromotion'] = update.clearPromotion;
    if (update.promotionalPricingPlan)
      _params['update.promotionalPricingPlan'] = update.promotionalPricingPlan;
    if (update.clearJumboPricingPlan)
      _params['update.clearJumboPricingPlan'] = update.clearJumboPricingPlan;
    if (update.jumboPricingPlan) _params['update.jumboPricingPlan'] = update.jumboPricingPlan;

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.teeTime.searchAndUpdateSlots;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  public getDeriveHandicap(params) {
    let _url = global.ServerUrls.deriveHandicap;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBookingReportList() {
    let _url = global.ServerUrls.getBookingReportList;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let reportList: any = resp;

          return reportList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getBuggyTypesList(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.getBuggyTypes;
    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let buggyTypesList: Array<BuggyType> = resp;

          return buggyTypesList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public registerFinancioClub(clubId: number): Observable<any> {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.external.finance.financio.initiateClub;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updatePartnerMembershipVerification(
    partnerId: string,
    playerMembershipId: number,
    params?: any
  ): Observable<any> {
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;
    let _playerMembershipId = playerMembershipId;
    let rePlayerMembershipId = /:playerMembershipId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.approveMembership;
    _url = _url.replace(rePartnerId, _partnerId);
    _url = _url.replace(rePlayerMembershipId, _playerMembershipId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.put,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public approveApplication(partnerId: string, params?: any): Observable<any> {
    let _partnerId = partnerId;
    let rePartnerId = /:partnerId/gi;

    let _url = global.ServerUrls.partnerDiscountCompany.approveApplications;
    _url = _url.replace(rePartnerId, _partnerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public addPlayerTypeWeb(
    file: any,
    imageURL: string,
    contentType: string,
    playerId: number,
    bookingPlayerType: string,
    authToken?: string,
    formData?: any
  ): Observable<any> {
    let _playerId;
    let _playerType;
    if (playerId) _playerId = 'playerId=' + playerId;
    if (bookingPlayerType) _playerType = '&bookingPlayerType=' + bookingPlayerType;
    let options = {
      file: file,
      authToken: authToken,
    };
    const _formData: FormData = new FormData();
    _formData.append('file', file);
    let _hdrs = {
      'Content-Type': 'multipart/form-data',
      'X-AUTH-TOKEN': authToken,
      'Player-Id': _playerId,
    };
    let _url = global.ServerUrls.assignBookingPlayerType + '?' + _playerId + _playerType;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.MULTIPART_FORM,
      _formData
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public updateStatusClubMembership(
    clubId: number,
    membershipId: number,
    params?: any
  ): Observable<any> {
    let _clubId;
    let _membershipId;
    let _params;

    if (params) _params = params;
    if (clubId) _clubId = clubId;
    if (membershipId) _membershipId = membershipId;

    let reClub = /:clubId/gi;
    let reMembership = /:membershipId/gi;

    let _url = global.ServerUrls.clubMemberships.updateStatus;
    _url = _url.replace(reClub, _clubId);
    _url = _url.replace(reMembership, _membershipId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML, _params);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubPaymentInstances(clubId: number, params?) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubPayments.getClubInstances;
    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubPaymentInstancesList: Array<ClubPaymentInstancePage> = resp;

          return clubPaymentInstancesList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public importClubPayments(clubId: number, file: any): Observable<any> {
    let _clubId = clubId;
    const _formData: FormData = new FormData();
    _formData.append('file', file);

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.playerAccounts.importClubPayments;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.MULTIPART_FORM,
      _formData
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getClubPaymentTransactions(params: any) {
    let _url = global.ServerUrls.playerAccounts.getClubPaymentTransactions;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubAccountTransactionPage: PlayerClubAccountTransactionPage = resp;

          return playerClubAccountTransactionPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchBookingAgent(
    partnerId: string,
    fromDate?: string,
    toDate?: string,
    statusType?: string,
    statusList?: Array<string>,
    clubId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    bookingMedium?: string,
    slotFrom?: string,
    slotTo?: string,
    bookingStart?: string
  ) {
    let _params = {};
    let _partnerId = partnerId ? '/' + partnerId : '';
    if (fromDate) _params['fromDate'] = fromDate;
    if (toDate) _params['toDate'] = toDate;
    if (statusType) _params['statusType'] = statusType;
    if (statusList) _params['statusList'] = statusList;
    if (clubId) _params['clubId'] = clubId;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (bookingMedium) _params['bookingMedium'] = bookingMedium.toUpperCase();
    if (slotFrom) _params['slotFrom'] = slotFrom;
    if (slotTo) _params['slotTo'] = slotTo;
    if (bookingStart) _params['bookingStart'] = bookingStart;

    let request = new RemoteRequest(
      global.ServerUrls.searchBookingAgent + _partnerId,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubBookingList: PagedData<TeeTimeBooking> = resp;
          clubBookingList.items.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
          });
          return clubBookingList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubPaymentImports(params: any) {
    let _url = global.ServerUrls.clubPayments.getImports;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerAccountPaymentImportPage: any = resp;

          return playerAccountPaymentImportPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public uploadPlayerCardDiscountWeb(
    file: any,
    imageURL: string,
    playerDiscountProgramId: number
  ): Observable<any> {
    let _pDiscountProgId;
    if (playerDiscountProgramId) _pDiscountProgId = '?id=' + playerDiscountProgramId;
    let options = {
      file: file,
    };
    const _formData: FormData = new FormData();
    _formData.append('file', file);
    let _hdrs = {
      'Content-Type': 'multipart/form-data',
    };
    let _url = global.ServerUrls.updatePlayerDiscountDocument + _pDiscountProgId;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.MULTIPART_FORM,
      _formData
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  public getCompPlayerAllScores(params: any) {
    let _url = global.ServerUrls.competition.getAllPlayerScores;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compPlayerScores: Array<CompetitionRound> = resp;

          return compPlayerScores;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  syncTransactions(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.syncTransactions;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  listExportMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listExportMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<any> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  listPaymentMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listPaymentMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<PaymentTrxnType> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  listPricingMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listPricingMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<TrxnTypePriceComponentMap> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  listRefundMappings(clubId: number) {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.listRefundMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<RefundTrxnType> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  listTrxnTypes(params?: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.finance.listTrxnTypes;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<TransactionType> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  listClubTrxnTypes(clubId: number, params?: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.finance.clubTrxnTypes.getList;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<TransactionType> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  listTrxnGroups(params?: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.finance.listTrxnGroups;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<TransactionGroup> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  addUpdateExportMappings(clubId: number, params: any) {
    let _params = params;
    let _trxnTypeId = params['transactionTypeId'];
    let reClubId = /:clubId/gi;
    let reTrxnTypeId = /:transactionTypeId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updateExportMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reTrxnTypeId, _trxnTypeId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  addUpdatePaymentMappings(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updatePaymentMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  addUpdatePricingMappings(clubId: number, params: any) {
    let _params = params;
    let _pricingComp = params['pricingComp'];
    let reClubId = /:clubId/gi;
    let rePricingComp = /:pricingComp/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updatePricingMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePricingComp, _pricingComp);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  addUpdateRefundMappings(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updateRefundMappings;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public deleteExportMappings(clubId: number, transactionTypeId: string): Observable<any> {
    let _params = {};
    let _clubId = clubId;
    let _transactionTypeId = transactionTypeId;
    let reClubId = /:clubId/gi;
    let reTrxnTypeId = /:transactionTypeId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.updateDeleteExportMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reTrxnTypeId, transactionTypeId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deletePaymentMappings(clubId: number, mappingId: string): Observable<any> {
    let _params = {};
    let reClubId = /:clubId/gi;
    let reMappingId = /:mappingId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deletePaymentMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reMappingId, mappingId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public deleteRefundMappings(clubId: number, mappingId: string): Observable<any> {
    let _params = {};
    let reClubId = /:clubId/gi;
    let reMappingId = /:mappingId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deleteRefundMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reMappingId, mappingId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deletePricingMappings(clubId: number, pricingComp: string): Observable<any> {
    let _params = {};
    let reClubId = /:clubId/gi;
    let rePricingComp = /:pricingComp/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deletePricingMappings;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePricingComp, pricingComp);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public deleteTrxn(clubId: number, trxnTypeId: string): Observable<any> {
    let _params = {};
    let reClubId = /:clubId/gi;
    let retrxnTypeId = /:transactionTypeId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.deleteTrxn;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(retrxnTypeId, trxnTypeId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addUpdateClubTrxnType(clubId: number, params: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.clubTrxnTypes.addType;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  getExtSystems(systemType?: any) {
    let _params = {
      systemType: systemType,
    };
    let _url = global.ServerUrls.external.system.getList;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<any> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getExtInterfaces(params?: any) {
    let _params = params;
    let _url = global.ServerUrls.external.system.getInterfaces;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<any> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getExtClubAcctSystem(clubId: number, systemId: string) {
    let reClubId = /:clubId/gi;
    let reSystemId = /:systemId/gi;

    let _url = global.ServerUrls.external.system.getAccounts;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reSystemId, systemId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: Array<any> = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getFinanceClubTransactions(params?: any) {
    let _params = params;

    let _url = global.ServerUrls.finance.listTransactions;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getExportInstancesList(params?: any) {
    let _params = params;

    let _url = global.ServerUrls.finance.exports.listInstances;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getExportInstanceDetails(instanceId: number) {
    let reInstanceId = /:instanceId/gi;

    let _url = global.ServerUrls.finance.exports.getInstanceDetails;
    _url = _url.replace(reInstanceId, instanceId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getExportClubTransactions(instanceId: number, params?: any) {
    let reInstanceId = /:instanceId/gi;
    let _params = params;

    let _url = global.ServerUrls.finance.exports.getInstanceTrxnsList;

    _url = _url.replace(reInstanceId, instanceId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  generateClubExport(params?: any) {
    let _params = params;
    let _url = global.ServerUrls.finance.exports.generate;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  generateClubTransactions(clubId: number, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.finance.generateTransactions;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  listClubComponents(clubId: number, params: any) {
    let reClubId = /:clubId/gi;
    let _params = params;

    let _url = global.ServerUrls.productsPricing.listClubComponents;

    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addUpdateClubComponents(clubId: number, params: any) {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.productsPricing.addUpdateClubComponents;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  getClubCompDetails(clubId: number, componentId: string) {
    let reClubId = /:clubId/gi;
    let reComponentId = /:componentId/gi;

    let _url = global.ServerUrls.producsPricing.getClubCompDetails;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reComponentId, componentId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteClubComponent(clubId: number, componentId: string) {
    let _params = {};
    let reClubId = /:clubId/gi;
    let reComponentId = /:componentId/gi;
    let _url = global.ServerUrls.productsPricing.deleteClubComponent;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reComponentId, componentId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  listTaxProfiles(params: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _clubId = params['clubId'];
    let _url = global.ServerUrls.taxProfiles.getList;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addUpdateTaxProfiles(clubId: number, params: any) {
    let _clubId = clubId;
    let reClubId = /:clubId/gi;
    let _params = params;
    let _url = global.ServerUrls.taxProfiles.addUpdate;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  toggleActiveTaxProfiles(clubId: number, profileId: string, active: boolean) {
    let _clubId;
    let reClubId = /:clubId/gi;
    let reProfileId = /:profileId/gi;
    let _url = global.ServerUrls.taxProfiles.toggleActive;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reProfileId, profileId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML);

    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteTaxProfiles(clubId: number, profileId: string) {
    let _params = {};
    let reClubId = /:clubId/gi;
    let reProfileId = /:profileId/gi;
    let _url = global.ServerUrls.taxProfiles.delete;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reProfileId, profileId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  getClubOrdersList(clubId: number, params: any) {
    let reClubId = /:clubId/gi;
    let _params = params;
    let _clubId = clubId;

    let _url = global.ServerUrls.clubOrder.getOrdersList;
    _url = _url.replace(reClubId, _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addClubOrder(clubId: number, items: Array<string>) {
    let _params = {
      items: items,
    };
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.clubOrder.addNewOrder;

    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  addOrderItems(clubId: number, orderId: number, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let _url = global.ServerUrls.clubOrder.items.add;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  updateOrderItems(clubId: number, orderId: number, itemId, params?: any) {
    let _params = params;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let reItemId = /:itemId/gi;
    let _url = global.ServerUrls.clubOrder.items.update;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reItemId, itemId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  deleteOrderItems(clubId: number, orderId: number, itemId: number) {
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let reItemId = /:itemId/gi;
    let _url = global.ServerUrls.clubOrder.items.delete;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reItemId, itemId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getClubOrderDetails(clubId: number, orderId: number) {
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let _clubId = clubId;
    let _orderId = orderId;
    let _url = global.ServerUrls.clubOrder.getOrderDetails;
    _url = _url.replace(reClubId, _clubId);
    _url = _url.replace(reOrderId, _orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteClubOrder(clubId: number, orderId: number) {
    let _params = {};
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let _url = global.ServerUrls.clubOrder.deleteOrder;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  updateClubOrderDetails(clubId: number, orderId: number, params: any) {
    let _url;
    _url = global.ServerUrls.clubOrder.updateOrderDetails;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  updateClubOrderStatus(clubId: number, orderId: number, status: string) {
    let _url;
    if (status === 'cancel') _url = global.ServerUrls.clubOrder.cancelOrder;
    else if (status === 'confirm') _url = global.ServerUrls.clubOrder.confirmOrder;
    else if (status === 'finalize') _url = global.ServerUrls.clubOrder.finalizeOrder;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(_url, this.requestMethod.put, ContentType.HTML);
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  onAddOrderPayment(clubId: number, orderId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.addPayment;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  onUpdateOrderPayment(clubId: number, orderId: number, paymentId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.updatePayment;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let rePaymentId = /:paymentId/gi;

    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(rePaymentId, paymentId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  onDeleteOrderPayment(clubId: number, orderId: number, paymentId: number) {
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let rePaymentId = /:paymentId/gi;
    let _url = global.ServerUrls.clubOrder.deletePayment;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(rePaymentId, paymentId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  listClubCustomers(clubId: number, search?: any) {
    let reClubId = /:clubId/gi;
    let _search = search;
    let _url = global.ServerUrls.clubOrder.listClubCustomers;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _search
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  addClubCustomer(clubId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.addClubCustomer;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  updateClubCustomer(clubId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.updateClubCustomer;
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }
  deleteClubCustomer(clubId: number, customerCode: string) {
    let reClubId = /:clubId/gi;
    let reCustomerCode = /:customerCode/gi;
    let _url = global.ServerUrls.clubOrder.deleteClubCustomer;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reCustomerCode, customerCode);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  doRefundOrder(clubId: number, orderId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.doRefundOrder;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  undoRefundOrder(clubId: number, orderId: number, refundId: number) {
    let _url;
    _url = global.ServerUrls.clubOrder.undoRefundOrder;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    let reRefundId = /:refundId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reRefundId, refundId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  chargeToAccountOrder(clubId: number, orderId: number, params: any) {
    let _params = params;
    let _url;
    _url = global.ServerUrls.clubOrder.chargeToAccount;
    let reClubId = /:clubId/gi;
    let reOrderId = /:orderId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getAgentClubSettings(partnerId: string, clubId: number) {
    let _params = {};
    if (partnerId) _params['partnerId'] = partnerId;
    if (clubId) _params['clubId'] = clubId;
    let _url = global.ServerUrls.partnerDiscountCompany.getAgentClubSettings;
    let reClubId = /:clubId/gi;
    let rePartnerId = /:partnerId/gi;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePartnerId, partnerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSettings: BookingAgentClubSetting = resp;
          return clubSettings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  getBookingByReference(clubId: number, bookingReference: string) {
    let reClubId = /:clubId/gi;
    let _params = {
      clubId: clubId,
      bookingReference: bookingReference,
    };
    let _url = global.ServerUrls.teeTime.getBookingByReference;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  checkBookingExistsByReference(clubId: number, bookingReference: string) {
    let reClubId = /:clubId/gi;
    let _params = {
      clubId: clubId,
      bookingReference: bookingReference,
    };
    let _url = global.ServerUrls.teeTime.getBookingByReference;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public searchBookingsByPartner(
    partnerId: string,
    programId?: string,
    startDate?: string,
    endDate?: string,
    statusType?: string,
    bookingStatuses?: Array<string>,
    clubId?: number,
    search?: string,
    pageSize?: number,
    pageNo?: number,
    bookingMedium?: string,
    slotFrom?: string,
    slotTo?: string,
    bookingStart?: string
  ) {
    let _params = {};
    let rePartnerId = /:partnerId/gi;
    let reProgramId = /:programId/gi;
    if (startDate) _params['startDate'] = startDate;
    if (endDate) _params['endDate'] = endDate;
    if (slotFrom) _params['slotFrom'] = slotFrom;
    if (slotTo) _params['slotTo'] = slotTo;
    if (bookingStart) _params['bookingStart'] = bookingStart;
    if (statusType) _params['statusType'] = statusType;
    if (bookingStatuses) _params['bookingStatuses'] = bookingStatuses;
    if (clubId) _params['clubId'] = clubId;
    if (pageSize) _params['pageSize'] = pageSize;
    if (pageNo) _params['pageNo'] = pageNo;
    if (search) _params['search'] = search;
    if (bookingMedium) _params['bookingMedium'] = bookingMedium.toUpperCase();
    let _url = '';
    if (programId) {
      _url = global.ServerUrls.partnerDiscountCompany.getProgramBookings;
      _url = _url.replace(reProgramId, programId);
    } else _url = global.ServerUrls.partnerDiscountCompany.getPartnerBookings;
    _url = _url.replace(rePartnerId, partnerId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubBookingList: PagedData<TeeTimeBooking> = resp;
          clubBookingList.items.forEach((tb: TeeTimeBooking) => {
            tb.bookingPlayers.forEach((p: TeeTimeBookingPlayer) => {
              JsonService.deriveFullUrl(p.player, 'profile');
              JsonService.deriveFullUrl(p.player, 'image');
              JsonService.deriveFullUrl(p.caddyAssigned, 'caddyImage');
              JsonService.deriveFullUrl(p.caddyPreferred, 'caddyImage');
            });
          });
          return clubBookingList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public changePasswordByAdmin(email: string, newPassword: string): Observable<any> {
    let _params = {
      email: email,
      newPassword: newPassword,
    };
    let _url = global.ServerUrls.changePasswordByAdmin;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  getPromoContexts(context: string) {
    let _params = {
      context: context,
    };
    let _url = global.ServerUrls.promo.getContexts;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getPromoIsActive(context: string) {
    let _params = {
      context: context,
    };
    let _url = global.ServerUrls.promo.isAnyActive;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  getPromoCode(context: string, couponCode: string) {
    let _params = {
      context: context,
      couponCode: couponCode,
    };
    let _url = global.ServerUrls.promo.getActiveCoupons;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;

          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getPlayerAccountStats(clubId: number, playerId: number, lastNMonths: number = 3) {
    let _params = {};
    // _params['clubId'] = clubId;
    // _params['playerId'] = playerId;
    _params['lastNMonths'] = lastNMonths;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getStats;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubStats: PlayerClubStat = resp;
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return playerClubStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public makeClubPayment(clubId: number, playerId: number, params: any): Observable<any> {
    // public updatePlayerPhoto(imageUrl: string, mimeType: string, playerId?: number): Observable<UploadResult>{
    let _clubId = clubId;
    let _playerId = playerId;
    let _params = params;

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.makePayment;
    _url = _url.replace(reClubId, clubId);
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getCompetitionCourseSlopeRatings(compId: number, allTeeBoxes?: boolean) {
    let _params = {
      allTeeBoxes: allTeeBoxes,
    };

    let reCompetitionId = /:compId/gi;
    let _url = global.ServerUrls.competitions.getCourseRatings;
    _url = _url.replace(reCompetitionId, compId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compRoundCourseRatings: Array<CompetitionRoundCourseRatings> = resp;
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compRoundCourseRatings;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompetitionDetails(compId: number) {
    let reCompetitionId = /:compId/gi;
    let _url = global.ServerUrls.competitions.getDetails;
    _url = _url.replace(reCompetitionId, compId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let competition: CompetitionData = resp;
          competition.sponsors.forEach((s: CompetitionSponsorInfo) => {
            JsonService.deriveFulImageURL(s, 'imageUrl');
            JsonService.deriveFulImageURL(s.sponsor, 'image');
          });

          JsonService.deriveFulImageURL(competition, 'playerPhoto');
          JsonService.deriveFulImageURL(competition, 'image');
          JsonService.deriveFulImageURL(competition, 'thumbnail');
          competition?.players.forEach((player: CompetitionPlayerData) => {
            JsonService.deriveFulImageURL(player, 'player.image');
            JsonService.deriveFulImageURL(player, 'player.profile');
          });
          if (competition?.leagueSeasons?.length) {
            competition.leagueSeasons.forEach((ls: any) => {
              JsonService.deriveFulImageURL(ls, 'leagueImage');
            });
          }
          competition?.competitionTeams?.forEach(ct => {
            if (ct.teamColor === '') ct.teamColor = '#000000';
            // JsonService.deriveFulImageURL(ct, 'teamLogo');

            if (ct?.teamLogo) JsonService.deriveFulImageURL(ct, 'teamLogo');
            else ct.teamLogo = 'assets/icons/teamwork.png';
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return competition;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompLeaderboard(compId: number, params: any) {
    let reCompetitionId = /:compId/gi;
    // let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.competitions.leaderboard;
    _url = _url.replace(reCompetitionId, compId);
    // _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leaderboard: LeaderBoard = resp;
          return leaderboard;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompScorecardsByPlayer(compId: number, playerId: number) {
    let reCompetitionId = /:compId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.competitions.getScorecardsByPlayer;
    _url = _url.replace(reCompetitionId, compId);
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerScorecard: PlayerScorecard = resp;
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return playerScorecard;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompScorecardsByRound(compId: number, roundNo: number) {
    let reCompetitionId = /:compId/gi;
    let reRoundNo = /:roundNo/gi;
    let _url = global.ServerUrls.competitions.getScorecardsByRound;
    _url = _url.replace(reCompetitionId, compId);
    _url = _url.replace(reRoundNo, roundNo);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let competitionScorecards: CompetitionScorecards = resp;
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return competitionScorecards;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  // public getCompLeaderboard(
  //   competitionId: number,
  //   orderBy?: number,
  //   roundNo?: number,
  //   categoryId?: string,
  //   isTeamEvent?: boolean
  // ): Observable<LeaderBoard> {
  //   if (!orderBy) orderBy = this.searchCriteria.competitionLeaderboardSortBy; //this.selectedOrderBy;

  //   if (!roundNo) roundNo = this.selectedRoundNo;

  //   if (!categoryId)
  //     categoryId = this.searchCriteria.competitionLeaderboardGroupBy; //this.selectedCategoryId;

  //   if (!isTeamEvent) isTeamEvent = this.isTeamEvent;

  //   let request = new RemoteRequest(
  //     global.ServerUrls.competitionLeaderboard,
  //     this.requestMethod.get,
  //     ContentType.URL_ENCODED_FORM_DATA,
  //     {
  //       competitionId: competitionId,
  //       roundNo: roundNo,
  //       categoryId: categoryId,
  //       orderBy: orderBy,
  //       isTeamEvent: isTeamEvent ? 'true' : 'false',
  //     }
  //   );

  //   return this.http
  //     .execute(request)
  //     .pipe(
  //       map((resp: any) => {
  //         let leaderBoard: any = resp;
  //         if (leaderBoard && leaderBoard.players)
  //           leaderBoard.players.forEach((p: LeaderBoardPlayer) => {
  //             JsonService.deriveFullUrl(p, 'imageURL');
  //           });
  //         return leaderBoard;
  //       })
  //     )
  //     .pipe(catchError(this.http.handleError))
  // }

  public getPlayerLastNStatements(lastNMonths: number) {
    let _statementId;
    let _params = {
      lastNMonths: lastNMonths,
    };

    let reClubId = /:clubId/gi;
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.playerAccounts.getLastNStatements;
    _url = _url.replace(reClubId, _params['clubId']);
    _url = _url.replace(rePlayerId, _params['playerId']);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let playerClubStats: PlayerClubStat = resp;

          return playerClubStats;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * Registers a palyer for the competition.
   * @param competitionId The ID of the competition
   * @param playerId The player id
   * @returns {Observable<R>} returns the
   */

  public compRegisterPlayer(
    competitionId: number,
    playerId: number,
    ignoreOverlap: boolean,
    sessionId?: number,
    feeTypeSelected: string = 'Auto', //Auto, Standard, ClubMember, OrganizerMember
    clubMembership?: string
  ): Observable<any> {
    let _params = {
      competitionId: competitionId,
      playerId: playerId,
      ignoreOverlap: ignoreOverlap,
      sessionId: sessionId,
      feeTypeSelected: feeTypeSelected,
      clubMembership: clubMembership,
    };

    let reCompId = /:compId/gi;
    let _url = global.ServerUrls.competitions.registerPlayer;
    _url = _url.replace(reCompId, competitionId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(map((resp: Response) => resp));
    // .pipe(catchError(this.http.handleError));
  }
  // public compRegisterPlayer(
  //   competitionId: number,
  //   playerId: number,
  //   ignoreOverlap: boolean,
  //   sessionId?: number,
  // ): Observable<ServerResult> {
  //   let request = new RemoteRequest(
  //     global.ServerUrls.newCompetitionRegister,
  //     this.requestMethod.post,
  //     ContentType.URL_ENCODED_FORM_DATA,
  //     {
  //       competitionId: competitionId,
  //       playerId: playerId,
  //       ignoreOverlap: ignoreOverlap,
  //       sessionId: sessionId,
  //     }
  //   );
  //   return this.http
  //     .execute(request)
  //     .pipe(map((resp: any) => resp))
  //     .pipe(catchError(this.http.handleError))
  // }

  public getCompFlightList(compId: number, roundNo: number) {
    let reCompetitionId = /:compId/gi;
    let reRoundNo = /:roundNo/gi;
    let _url = global.ServerUrls.competitions.getFlightList;
    _url = _url.replace(reCompetitionId, compId);
    _url = _url.replace(reRoundNo, roundNo);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let flightData: Array<FlightData> = resp;
          flightData.forEach(f => {
            f.flightMembers.forEach((fm: PlayerInFlightData) => {
              JsonService.deriveFullUrl(fm.player, 'playerPhoto');
            });
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return flightData;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  testSendBookingProgress(
    type: string = 'success',
    clubId: number,
    bookingReference: string,
    params: any
  ) {
    let _params = params;
    if (clubId) _params['clubId'] = clubId;
    if (bookingReference) _params['bookingReference'] = bookingReference;
    let _url = global.ServerUrls.teeTimeBooking.test.sendBookingSuccess;
    if (type === 'failed') {
      _url = global.ServerUrls.teeTimeBooking.test.sendBookingFailed;
    }
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let result: any = resp;
          //??console.log("Booking Cancel Guard - ",resetCancelGuard," : ",result)
          return result;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * @param clubId integer
   * @param partnerId string
   * @param mygolfNewsOnly (boolean)
   * @param startDate (date string)
   * @param endDate (date string)
   * @param activeOn (date string)
   * @param activeOrInactive A - Active news only, I - Inactive only, B - Both (Default). This parameter is ignored if activeOn is specified.
   * @param search The filter text used on the fields title, news brief and full news
   * @param pageSize Default value : 30
   * @param pageNo Default value : 1
   *
   **/
  getNewsList(params): Observable<NewsPage> {
    let url = global.ServerUrls.news.getNewsList;
    let _params = {};
    if (!appProps.filterNewsPromoByDates) params['startDate'] = null;
    _params = removeEmptyKeys(params);
    let request = new RemoteRequest(
      url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((result: any) => {
        let list: News[] = result.items;
        if (list && list.length)
          result.items.forEach(news => {
            JsonService.deriveFullImageUrlArrayObject(news.images);
            JsonService.deriveFullUrl(news?.club, 'clubLogo');
            JsonService.deriveFullUrl(news?.club, 'clubImage');
            JsonService.deriveFullUrl(news?.club, 'clubThumbnail');
            JsonService.deriveFullUrl(news?.partner, 'partnerImage');
          });
        return result;
      })
    );
  }

  getNewsDetails() {}

  /**
   * @param clubId integer
   * @param partnerId string
   * @param mygolfOnly (boolean)
   * @param startDate (date string)
   * @param endDate (date string)
   * @param activeOn (date string)
   * @param activeOrInactive A - Active news only, I - Inactive only, B - Both (Default). This parameter is ignored if activeOn is specified.
   * @param search The filter text used on the fields title, news brief and full news
   * @param pageSize Default value : 30
   * @param pageNo Default value : 1
   *
   **/
  getPromoAdsList(params): Observable<OffersAndAdvertisementPage> {
    let url = global.ServerUrls.offers.getPromotionList;
    let _params = {};
    if (!appProps.filterNewsPromoByDates) params['startDate'] = null;
    _params = removeEmptyKeys(params);
    let request = new RemoteRequest(
      url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http.execute(request).pipe(
      map((result: any) => {
        let list: OfferAndAdvertisement[] = result.items;
        if (list && list.length)
          result.items.forEach(promotion => {
            JsonService.deriveFullImageUrlArrayObject(promotion.images);
            JsonService.deriveFullUrl(promotion?.club, 'clubLogo');
            JsonService.deriveFullUrl(promotion?.club, 'clubImage');
            JsonService.deriveFullUrl(promotion?.club, 'clubThumbnail');
            JsonService.deriveFullUrl(promotion?.partner, 'partnerImage');
          });
        return result;
      })
    );
  }

  getPromoAdsDetails() {}

  public updatePlayerPhotoWeb(
    file: any,
    imageURL: string,
    contentType: string,
    playerId: number,
    authToken: string,
    formData?: any
  ): Observable<any> {
    let _playerId;
    let _playerType;
    let options = {
      file: file,
      authToken: authToken,
    };
    const _formData: FormData = new FormData();
    _formData.append('file', file);
    _formData.append('playerId', String(playerId));
    let _hdrs = {
      'Content-Type': 'multipart/form-data',
      'X-AUTH-TOKEN': authToken,
      'Player-Id': _playerId,
    };
    let _url = global.ServerUrls.updatePhoto;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.MULTIPART_FORM,
      _formData
    );
    return this.http.execute(request).pipe(map((resp: any) => resp));
  }

  public compCancelWaitlist(competitionId: number, playerId: number): Observable<any> {
    let _params = {
      competitionId: competitionId,
      playerId: playerId,
    };

    let reCompId = /:compId/gi;
    let _url = global.ServerUrls.competitions.cancelWaitList;
    _url = _url.replace(reCompId, competitionId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public getPlayerVouchers(params: any) {
    console.log('get player vouchers: ', params);
    let _params = params;
    let request = new RemoteRequest(
      global.ServerUrls.getPlayerVouchers,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let vouchersPage: TeeTimeClubVoucherPage = resp;
          return vouchersPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public searchFacilityBookings(params: any): Observable<ClubFacilityBookingPage> {
    const url = global.ServerUrls.outlet.bookings.search;
    const request = new RemoteRequest(
      url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );

    return this.http.execute(request).pipe(
      map((resp: ClubFacilityBookingPage) => resp),
      catchError(this.http.handleError)
    );
  }

  public getClubOutletType(clubId: number): Observable<Array<any>> {
    let _clubId;
    let _params = {};
    if (clubId) _clubId = clubId;

    let reClub = /:clubId/gi;

    let _url = global.ServerUrls.outlet.getClubOutletTypes;
    _url = _url.replace(reClub, _clubId);
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getOutletType(): Observable<Array<any>> {
    let _url = global.ServerUrls.outlet.getOutletTypes;
    // console.debug("get club outlet list : ", _params , _clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let _resp: any = resp;
          let outletTypes: Array<any> = _resp;
          return outletTypes;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getOutletDetails(outletId: number) {
    let reOutletId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.getDetails;
    _url = _url.replace(reOutletId, outletId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubOutlet: ClubOutlet = resp;

          JsonService.deriveFullImageUrlArrayObject(clubOutlet.images);

          return clubOutlet;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public searchFacilities(clubId: number, params: any) {
    let _params = params;

    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.outlet.searchFacilities;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let bookableFacilityResult: BookableFacilitySearchResult = resp;
          return bookableFacilityResult;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public bookFacilitySlot(reqBookSlot: FacilityBookingRequest): Observable<any> {
    let _reqBookSlot = reqBookSlot;
    let request = new RemoteRequest(
      global.ServerUrls.outlet.bookings.bookSlot,
      this.requestMethod.post,
      ContentType.JSON,
      _reqBookSlot
    );
    return this.http
      .execute(request)
      .pipe(map((resp: Response) => resp))
      .pipe(catchError(this.http.handleError));
  }

  public searchOrders(params) {
    let _url = global.ServerUrls.order.search;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let orderListPage: OrderPage = resp;
          if (orderListPage && orderListPage.totalItems > 0) {
            orderListPage.items.forEach((order: Order) => {
              JsonService.deriveFulImageURL(order.club, 'clubLogo');
              JsonService.deriveFulImageURL(order.club, 'clubImage');
              JsonService.deriveFulImageURL(order.club, 'clubThumbnail');
            });
          }
          return orderListPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompTeamScores(params: any): Observable<Array<TeamScores>> {
    const url = global.ServerUrls.getCompTeamScores;
    const request = new RemoteRequest(
      url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );

    return this.http.execute(request).pipe(
      map((resp: Array<TeamScores>) => {
        resp.forEach((t: TeamScores) => {
          if (t?.teamLogo) JsonService.deriveFulImageURL(t, 'teamLogo');
          else t.teamLogo = 'assets/icons/teamwork.png';
        });
        return resp;
      }),
      catchError(this.http.handleError)
    );
  }

  getoutletInfoById(outletId: number) {
    let _outletId = /:outletId/gi;
    let _url = global.ServerUrls.outlet.getInfo;
    _url = _url.replace(_outletId, outletId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let data: any = resp;
          if (data) {
            JsonService.deriveFullImageUrlArrayObject(data.images);
          }
          return data;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  cancelFacilityBooking(bookingId: number) {
    let reBookingId = /:bookingId/gi;

    let _url = global.ServerUrls.outlet.bookings.cancel;

    _url = _url.replace(reBookingId, bookingId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  deleteFacilityBookingOrder(orderId: number) {
    let reOrderId = /:orderId/gi;
    let _url = global.ServerUrls.outlet.bookings.removeOrder;

    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.delete,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public searchFacilityOrders(params) {
    let _url = global.ServerUrls.order.searchFacilityOrders;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let orderListPage: any = resp;
          if (orderListPage) {
            orderListPage.forEach((order: any) => {
              JsonService.deriveFulImageURL(order.club, 'clubLogo');
              JsonService.deriveFulImageURL(order.club, 'clubImage');
              JsonService.deriveFulImageURL(order.club, 'clubThumbnail');
              JsonService.deriveFulImageURL(order.clubLite, 'clubLogo');
              JsonService.deriveFulImageURL(order.clubLite, 'clubImage');
              JsonService.deriveFulImageURL(order.clubLite, 'clubThumbnail');
            });
          }
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getFacilityBookingOrderById(orderId: number) {
    let reOrderId = /:Id/gi;
    let _url = global.ServerUrls.order.facilityBookingById;

    _url = _url.replace(reOrderId, orderId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public createOrderForBooking(bookingNew: boolean, cartId: string): Observable<any> {
    let _cartId = bookingNew ? this.orderService.getCartId() : cartId;
    let _params = {
      cartId: _cartId,
    };
    let request = new RemoteRequest(
      global.ServerUrls.outlet.bookings.createOrder,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updatePaxForFacBooking(bookingId: number, pax: BookingPax): Observable<any> {
    let _bookingId = bookingId;
    let _params = {
      pax: pax,
    };
    let reBookingId = /:bookingId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.outlet.bookings.updatePax;
    url = url.replace(reBookingId, _bookingId);
    console.debug('updating pax : ', _bookingId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, pax);
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public updateCountForFacBooking(bookingId: number, params: AdditionalItemCount): Observable<any> {
    let _bookingId = bookingId;
    let _params = params;
    let reBookingId = /:bookingId/gi;
    // let headers = {};
    // if (captchaResponse && captchaResponse.length > 0) headers['captcha-response'] = captchaResponse;
    // else headers = null;
    let url = global.ServerUrls.outlet.bookings.updateAdditionalCount;
    url = url.replace(reBookingId, _bookingId);
    console.debug('updating pax : ', _bookingId, url, _params);
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.JSON, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   * @param playerId: number
   * @param eInvoicingOption: string <None|Individual|Company>
   * @param country: string
   **/
  public updatePlayerEInvoiceInfo(
    playerId: number,
    eInvoicingOption: string,
    country: string,
    params: any
  ): Observable<any> {
    let _playerId = playerId;
    let rePlayerId = /:playerId/gi;
    let _params = params;
    _params['eInvoicingOption'] = eInvoicingOption;

    let url = global.ServerUrls.eInvoicing.saveForPlayer;
    url = url.replace(rePlayerId, _playerId);
    let request = new RemoteRequest(
      url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getEInvoiceEntityDetails(countryId: string, taxIdentificationNumber: string) {
    let _params = {
      countryId: countryId,
      tin: taxIdentificationNumber,
    };
    let _url = global.ServerUrls.eInvoicing.getEntityDetails;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getEInvoiceEntityList(countryId: string, taxIdentificationNumber: string) {
    let _params = {
      countryId: countryId,
      tin: taxIdentificationNumber,
    };
    let _url = global.ServerUrls.eInvoicing.getEntityList;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getPlayerDetails(playerId: number) {
    let rePlayerId = /:playerId/gi;
    let _url = global.ServerUrls.getPlayerDetails;
    _url = _url.replace(rePlayerId, playerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
    // getPlayerDetails
  }

  /**
   *
   * @param params
   * @returns
   */
  public getAllClubSlotCounts(type: string, params: any) {
    console.debug('all club slot count [service]: ', type, params);
    let _url = '';
    let _clubId;

    if (type === 'all') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.all;
    } else if (type === 'favouriteClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.favouriteClubs;
    } else if (type === 'nearbyClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.nearbyClubs;
    } else if (type === 'membershipClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.membershipClubs;
    } else if (type === 'recentClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.recentClubs;
    }
    // let _cartId = this.orderService.getCartId();
    // let _params = {
    //     cartId: _cartId
    // };
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          console.debug('all club slot count [service - result]: ', resp);
          let clubSlotCountsPage: ClubSlotCountsPage = resp; // resp.json();
          if (
            clubSlotCountsPage &&
            clubSlotCountsPage.items &&
            clubSlotCountsPage.items.length > 0
          ) {
            clubSlotCountsPage.items.forEach((clubSlotCount: ClubSlotCounts) => {
              JsonService.deriveFulImageURL(clubSlotCount.club, 'clubLogo');
              JsonService.deriveFulImageURL(clubSlotCount.club, 'clubImage');
              JsonService.deriveFulImageURL(clubSlotCount.club, 'clubThumbnail');
              JsonService.deriveFulImageURL(clubSlotCount.slotCounts, 'clubLogo');
              JsonService.deriveFulImageURL(clubSlotCount.slotCounts, 'clubImage');
              JsonService.deriveFulImageURL(clubSlotCount.slotCounts, 'clubThumbnail');
            });
          }
          return clubSlotCountsPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  /**
   *
   * @param type
   * These are possible values for the type : all | singleClub | favouriteClubs | nearbyClubs
   * This will return slot counts along with Club Info
   * @param params
   * @returns
   */
  public getClubSlotCounts(type: string, params: any) {
    let _url = '';
    let _clubId;

    if (type === 'all') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.all;
    } else if (type === 'favouriteClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.favouriteClubs;
    } else if (type === 'nearbyClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.nearbyClubs;
    } else if (type === 'membershipClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.membershipClubs;
    } else if (type === 'recentClubs') {
      _url = global.ServerUrls.teeTime.clubSlotCounts.recentClubs;
    }
    // let _cartId = this.orderService.getCartId();
    // let _params = {
    //     cartId: _cartId
    // };
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubSlotCountsList: Array<ClubSlotCounts> = resp; // resp.json();
          if (clubSlotCountsList && clubSlotCountsList.length > 0) {
            clubSlotCountsList.forEach((clubSlotCount: ClubSlotCounts) => {
              JsonService.deriveFulImageURL(clubSlotCount.club, 'clubLogo');
              JsonService.deriveFulImageURL(clubSlotCount.club, 'clubImage');
              JsonService.deriveFulImageURL(clubSlotCount.club, 'clubThumbnail');
              JsonService.deriveFulImageURL(clubSlotCount.slotCounts, 'clubLogo');
              JsonService.deriveFulImageURL(clubSlotCount.slotCounts, 'clubImage');
              JsonService.deriveFulImageURL(clubSlotCount.slotCounts, 'clubThumbnail');
            });
          }
          return clubSlotCountsList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubSlotPriceInfo(clubId: number, forDate: string) {
    let _url = global.ServerUrls.teeTime.getClubSlotPriceInfo;
    let _params = {
      forDate: forDate,
    };
    let reClubId = /:clubId/gi;
    _url = _url.replace(reClubId, clubId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let slotPriceInfo: TSlotPrice = resp; // resp.json();
          return slotPriceInfo;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubSlotList(params: any) {
    let _url = '';
    let _clubId;
    let _courseId;

    _url = global.ServerUrls.teeTime.listSlots;
    let reClubId = /:clubId/gi;
    let reCourseId = /:courseId/gi;
    if (params && params['clubId']) _clubId = params['clubId'];
    _url = _url.replace(reClubId, _clubId);
    if (params && params['courseId']) _courseId = params['courseId'];
    _url = _url.replace(reCourseId, _courseId);

    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubTSlotList: ClubTSlotList = resp; //.json();
          if (clubTSlotList) {
            JsonService.deriveFulImageURL(clubTSlotList.club, 'clubLogo');
            JsonService.deriveFulImageURL(clubTSlotList.club, 'clubImage');
            JsonService.deriveFulImageURL(clubTSlotList.club, 'clubThumbnail');
            JsonService.deriveFulImageURL(clubTSlotList.course, 'courseImage');
            JsonService.deriveFulImageURL(clubTSlotList.course, 'courseThumbnail');
            if (clubTSlotList.slots && clubTSlotList.slots.length > 0) {
              clubTSlotList.slots.forEach(s => {
                JsonService.deriveFullUrl(s.slot.startCourse, 'courseImage');
              });
            }
          }
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return clubTSlotList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getClubCoursesData(clubId: number): Observable<Array<ClubCourseData>> {
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.getClubCoursesData;
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let courses: Array<ClubCourseData> = resp;
          courses.forEach((c: ClubCourseData) => {
            JsonService.deriveFullUrl(c, 'courseImage');
            JsonService.deriveFullUrl(c, 'courseThumbnail');
            c.holes.forEach((h: ClubCourseHoleData) => {
              JsonService.deriveFullUrl(h, 'image');
              JsonService.deriveFullUrl(h, 'thumbnail');
            });
          });
          return courses;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public registerAppVisit(appVersion: string = '5.0.0'): Observable<any> {
    let _appVersion = appVersion;
    if (appProps?.majorAppVersion) _appVersion = appProps.majorAppVersion;
    let url = global.ServerUrls.players.registerAppVisit + `?appVersion=${_appVersion}`;
    let request = new RemoteRequest(url, this.requestMethod.post, ContentType.HTML);
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompetitionsList(pageNo: number = 1, params: any) {
    params['pageNo'] = pageNo;

    if (params['startDate']) params['startDate'] = moment(params['startDate']).format('YYYY-MM-DD');
    if (params['endDate']) params['endDate'] = moment(params['endDate']).format('YYYY-MM-DD');
    if (params['status'] === 'all') params['status'] = '';
    let _url = global.ServerUrls.competitions.getList;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compDataPage: CompetitionDataPage = resp;
          compDataPage?.items.forEach((comp: CompetitionData) => {
            if (comp?.id) comp.competitionId = comp.id;
            JsonService.deriveFullUrl(comp, 'playerPhoto');
            JsonService.deriveFullUrl(comp, 'image');
            JsonService.deriveFullUrl(comp, 'thumbnail');
            comp?.players.forEach((player: CompetitionPlayerData) => {
              JsonService.deriveFullUrl(player, 'player.image');
              JsonService.deriveFullUrl(player, 'player.profile');
            });
            if (comp?.leagueSeasons?.length) {
              comp.leagueSeasons.forEach((ls: any) => {
                JsonService.deriveFullUrl(ls, 'leagueImage');
              });
            }
            comp?.competitionTeams?.forEach(ct => {
              JsonService.deriveFulImageURL(ct, 'teamLogo');
              if (ct?.teamLogo) JsonService.deriveFulImageURL(ct, 'teamLogo');
              else ct.teamLogo = 'assets/icons/teamwork.png';
            });
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompListLite(pageNo: number = 1, params: any) {
    params['pageNo'] = pageNo;

    if (params['startDate']) params['startDate'] = moment(params['startDate']).format('YYYY-MM-DD');
    if (params['endDate']) params['endDate'] = moment(params['endDate']).format('YYYY-MM-DD');
    if (params['status'] === 'all') params['status'] = '';
    let _url = global.ServerUrls.competitions.getListLite;
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compDataPage: CompetitionDataLitePage = resp;
          compDataPage?.items.forEach((comp: CompetitionDataLite) => {
            if (comp?.id) JsonService.deriveFullUrl(comp, 'playerPhoto');
            JsonService.deriveFullUrl(comp, 'image');
            JsonService.deriveFullUrl(comp, 'thumbnail');
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompListLiteSecured(pageNo: number = 1, params: any) {
    params['pageNo'] = pageNo;

    if (params['startDate']) params['startDate'] = moment(params['startDate']).format('YYYY-MM-DD');
    if (params['endDate']) params['endDate'] = moment(params['endDate']).format('YYYY-MM-DD');
    if (params['status'] === 'all') params['status'] = '';
    if (params['countryId'] === null || !params['countryId']) delete params['countryId'];
    for (let key in params) {
      if (params[key] === null || params[key] === undefined) delete params[key];
    }
    let _url = global.ServerUrls.competitions.getListLiteSecured;
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compDataPage: CompetitionDataLitePage = resp;
          compDataPage?.items.forEach((comp: CompetitionDataLite) => {
            if (comp?.id)
              // comp.competitionId = comp.id;
              JsonService.deriveFullUrl(comp, 'playerPhoto');
            JsonService.deriveFullUrl(comp, 'image');
            JsonService.deriveFullUrl(comp, 'thumbnail');
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompRegisteredPlayers(compId: number, sortBy: string = 'name') {
    let _params = {
      sortBy: sortBy,
    };

    let _url = global.ServerUrls.competitions.getRegisteredPlayers;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compPlayerList: Array<CompetitionPlayerData> = resp;
          compPlayerList?.forEach((compPlayer: CompetitionPlayerData) => {
            if (compPlayer?.player) JsonService.deriveFullUrl(compPlayer?.player, 'image');
            JsonService.deriveFullUrl(compPlayer?.player, 'profile');
            JsonService.deriveFullUrl(compPlayer?.player?.userProfile, 'photo');
            JsonService.deriveFullUrl(compPlayer?.player?.userProfile, 'profileImage');
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return compPlayerList;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getOrganizersList(params: any) {
    let _url = global.ServerUrls.organizers.getList;
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let organizerDataPage: OrganizerDataPage = resp;
          organizerDataPage?.items.forEach((organizer: OrganizerData) => {
            JsonService.deriveFullUrl(organizer, 'image');
            JsonService.deriveFullUrl(organizer?.partner, 'partnerImage');
            JsonService.deriveFullUrl(organizer?.country, 'flagUrl');
            JsonService.deriveFullUrl(organizer?.club, 'clubImage');
            JsonService.deriveFullUrl(organizer?.club, 'clubThumbnail');
            JsonService.deriveFullUrl(organizer?.club, 'clubLogo');
          });
          return organizerDataPage;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getOrganizerInfo(organizerId: number): Observable<OrganizerData> {
    let _url = global.ServerUrls.organizers.getInfo;
    let reOrgId = /:organizerId/gi;
    _url = _url.replace(reOrgId, organizerId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let clubInfo: ClubInfo = resp;
          if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = 'document/img/default_club.png';
          JsonService.deriveFullUrl(clubInfo, 'clubImage');
          return clubInfo;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  getFacilityOrderById(clubId: number, orderId: number) {
    let reOrderId = /:orderId/gi;
    let reClubId = /:clubId/gi;
    let _url = global.ServerUrls.order.getOrder;

    _url = _url.replace(reOrderId, orderId);
    _url = _url.replace(reClubId, clubId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: Response) => {
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getOOMposition(
    seasonId: number,
    orderBy: string = 'league',
    qualifiedOnly: boolean = false
  ) {
    let _params = {
      orderBy: orderBy,
      qualifiedOnly: qualifiedOnly,
    };

    let _url = global.ServerUrls.compLeagueSeasons.getOOMposition;
    let reSeasonId = /:seasonId/gi;
    _url = _url.replace(reSeasonId, seasonId);
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leaguePlayerPositions: Array<LeaguePlayerTotal> = resp;
          leaguePlayerPositions?.forEach((oomPlayer: LeaguePlayerTotal) => {
            if (oomPlayer?.player)
              // comp.competitionId = comp.id;
              // JsonService.deriveFullUrl(oomPlayer?.player, 'playerPhoto');
              JsonService.deriveFullUrl(oomPlayer?.player, 'image');
            // JsonService.deriveFullUrl(oomPlayer?.player, 'thumbnail');
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return leaguePlayerPositions;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getLeagueCompPlayerTotals(seasonId: number, playerId: number) {
    let _url = global.ServerUrls.compLeagueSeasons.getPlayerCompetitionTotals;
    let reSeasonId = /:seasonId/gi;
    _url = _url.replace(reSeasonId, seasonId);
    let rePlayerId = /:playerId/gi;
    _url = _url.replace(rePlayerId, playerId);
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let leagueCompPlayerTotal: Array<LeagueCompetitionPlayerTotal> = resp;
          leagueCompPlayerTotal?.forEach((lcpt: LeagueCompetitionPlayerTotal) => {
            if (lcpt?.player) {
              JsonService.deriveFulImageURL(lcpt?.player, 'image');
              JsonService.deriveFulImageURL(lcpt?.player, 'profile');
            }
            if (lcpt?.competition) {
              JsonService.deriveFulImageURL(lcpt?.competition, 'image');
              JsonService.deriveFulImageURL(lcpt?.competition, 'thumbnail');
            }
          });
          //  //??console.log("club flight service first - booking Opts : ", bookingOptions, resp, resp.json())
          return leagueCompPlayerTotal;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompApplicableFee(
    compId: number,
    playerIds: Array<number>,
    toRederive: boolean = false
  ) {
    let _params = {
      playerIds: playerIds,
    };
    let _method = this.requestMethod.get;
    let _url = global.ServerUrls.competitions.getApplicableFee;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    if (toRederive) _method = this.requestMethod.post;
    // +"?pageNo="+params['pageNo']+"&pageSize="+params['pageSize'];
    let request = new RemoteRequest(_url, _method, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compFeeApplicable: Array<CompetitionFeeApplicable> = resp;
          return compFeeApplicable;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompEstimatedFee(compId: number, playerId: number) {
    let _params = {
      playerId: playerId,
    };
    let _method = this.requestMethod.get;
    let _url = global.ServerUrls.competitions.getEstimatedFee;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let request = new RemoteRequest(_url, _method, ContentType.URL_ENCODED_FORM_DATA, _params);
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compFeeApplicable: CompetitionFeeApplicable = resp;
          return compFeeApplicable;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  chargeToAccountCompFee(compId: number, playerId: number, amount: number) {
    let _params = {
      playerId: playerId,
      amount: amount,
    };
    let _url;
    _url = global.ServerUrls.competitions.chargeFeeToAccount;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(map((resp: any) => resp))
      .pipe(catchError(this.http.handleError));
  }

  setCompMatchDrawBetween(
    compId: number,
    matchId: number,
    holeNo: number,
    drawingTeams?: Array<number>
  ) {
    let _params = {
      drawingTeams: drawingTeams,
    };
    let _url = global.ServerUrls.competition.matchPlay.scoringDrawBetween;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let reMatchId = /:matchId/gi;
    _url = _url.replace(reMatchId, matchId);
    let reHoleNo = /:holeNo/gi;
    _url = _url.replace(reHoleNo, holeNo);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: CompetitionMatch) => {
          resp?.competitionTeams?.forEach(ct => {
            // JsonService.deriveFulImageURL(ct.competitionTeam, 'teamLogo');
            if (ct?.competitionTeam?.teamLogo)
              JsonService.deriveFulImageURL(ct?.competitionTeam, 'teamLogo');
            else ct.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
          });
          resp?.participants?.forEach(cp => {
            JsonService.deriveFulImageURL(cp.player, 'playerPhoto');
          });
          console.debug('[service] get comp match : ', resp);

          resp?.competitionTeams?.sort((a, b) => {
            if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
            else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
            else return 0;
          });
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  setCompMatchWonBy(compId: number, matchId: number, holeNo: number, winningTeam: number) {
    let _params = {
      winningTeam: winningTeam,
    };
    let _url = global.ServerUrls.competition.matchPlay.scoringWonBy;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let reMatchId = /:matchId/gi;
    _url = _url.replace(reMatchId, matchId);
    let reHoleNo = /:holeNo/gi;
    _url = _url.replace(reHoleNo, holeNo);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: CompetitionMatch) => {
          resp?.competitionTeams?.forEach(ct => {
            // JsonService.deriveFulImageURL(ct.competitionTeam, 'teamLogo');
            if (ct?.competitionTeam?.teamLogo)
              JsonService.deriveFulImageURL(ct?.competitionTeam, 'teamLogo');
            else ct.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
          });
          resp?.participants?.forEach(cp => {
            JsonService.deriveFulImageURL(cp.player, 'playerPhoto');
          });
          console.debug('[service] get comp match : ', resp);
          resp?.competitionTeams?.sort((a, b) => {
            if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
            else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
            else return 0;
          });
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  resetCompMatchHoleScore(compId: number, matchId: number, holeNo: number) {
    let _url = global.ServerUrls.competition.matchPlay.resetMatchHoleScore;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let reMatchId = /:matchId/gi;
    _url = _url.replace(reMatchId, matchId);
    let reHoleNo = /:holeNo/gi;
    _url = _url.replace(reHoleNo, holeNo);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: CompetitionMatch) => {
          resp?.competitionTeams?.forEach(ct => {
            // JsonService.deriveFulImageURL(ct.competitionTeam, 'teamLogo');
            if (ct?.competitionTeam?.teamLogo)
              JsonService.deriveFulImageURL(ct?.competitionTeam, 'teamLogo');
            else ct.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
          });
          resp?.participants?.forEach(cp => {
            JsonService.deriveFulImageURL(cp.player, 'playerPhoto');
          });
          console.debug('[service] get comp match : ', resp);

          resp?.competitionTeams?.sort((a, b) => {
            if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
            else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
            else return 0;
          });
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompMatches(compId: number, roundNo?: number): Observable<Array<CompetitionMatch>> {
    let _params = {
      roundNo: roundNo,
    };
    let _url = global.ServerUrls.competition.matchPlay.listMatches;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compMatches: Array<CompetitionMatch> = resp;
          compMatches?.forEach(cm => {
            cm?.competitionTeams?.forEach(ct => {
              // JsonService.deriveFulImageURL(ct.competitionTeam, 'teamLogo');
              if (ct?.competitionTeam?.teamLogo)
                JsonService.deriveFulImageURL(ct?.competitionTeam, 'teamLogo');
              else ct.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
            });
            cm?.participants?.forEach(cp => {
              JsonService.deriveFulImageURL(cp.player, 'playerPhoto');
            });
            cm?.competitionTeams?.sort((a, b) => {
              if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
              else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
              else return 0;
            });
          });
          return compMatches;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  submitCompMatch(compId: number, matchId: number) {
    let _url = global.ServerUrls.competition.matchPlay.submitMatch;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let reMatchId = /:matchId/gi;
    _url = _url.replace(reMatchId, matchId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: CompetitionMatch) => {
          resp?.competitionTeams?.forEach(ct => {
            // JsonService.deriveFulImageURL(ct.competitionTeam, 'teamLogo');
            if (ct?.competitionTeam?.teamLogo)
              JsonService.deriveFulImageURL(ct?.competitionTeam, 'teamLogo');
            else ct.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
          });
          resp?.participants?.forEach(cp => {
            JsonService.deriveFulImageURL(cp.player, 'playerPhoto');
          });
          resp?.competitionTeams?.sort((a, b) => {
            if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
            else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
            else return 0;
          });
          console.debug('[service] get comp match : ', resp);
          return resp;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompMatchById(compId: number, matchId: number): Observable<CompetitionMatch> {
    let _url = global.ServerUrls.competition.matchPlay.getCompMatchById;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let reMatchId = /:matchId/gi;
    _url = _url.replace(reMatchId, matchId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compMatches: CompetitionMatch = resp;
          compMatches?.competitionTeams?.forEach(ct => {
            // JsonService.deriveFulImageURL(ct.competitionTeam, 'teamLogo');
            if (ct?.competitionTeam?.teamLogo)
              JsonService.deriveFulImageURL(ct?.competitionTeam, 'teamLogo');
            else ct.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
          });
          compMatches?.participants?.forEach(cp => {
            JsonService.deriveFulImageURL(cp.player, 'playerPhoto');
          });
          compMatches?.competitionTeams?.sort((a, b) => {
            if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
            else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
            else return 0;
          });
          return compMatches;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getCompMatchPlayLeaderboard(
    compId: number,
    roundNo?: number
  ): Observable<CompetitionMatchPlayLeaderboard> {
    let _params = {
      roundNo: roundNo,
    };
    let _url = global.ServerUrls.competition.matchPlay.leaderboard;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: CompetitionMatchPlayLeaderboard) => {
          let matchPlayerLeaderboard: CompetitionMatchPlayLeaderboard = resp;
          JsonService.deriveFulImageURL(matchPlayerLeaderboard?.competition, 'clubImage');
          JsonService.deriveFulImageURL(matchPlayerLeaderboard?.competition, 'image');
          JsonService.deriveFulImageURL(matchPlayerLeaderboard?.competition, 'thumbnail');
          matchPlayerLeaderboard?.groupLeaderboards?.forEach(gpl => {
            gpl?.teams?.forEach(gt => {
              JsonService.deriveFulImageURL(gt, 'teamLogo', 'assets/icons/teamwork.png');
            });
          });
          matchPlayerLeaderboard?.teams.forEach((t: CompetitionMatchPlayLeaderboardTeam) => {
            // JsonService.deriveFulImageURL(t, 'teamLogo');
            if (t?.teamLogo) JsonService.deriveFulImageURL(t, 'teamLogo');
            else t.teamLogo = 'assets/icons/teamwork.png';
          });
          matchPlayerLeaderboard?.teams.sort((ta, tb) => {
            return ta?.competitionTeamId - tb?.competitionTeamId;
          });
          matchPlayerLeaderboard?.matches.forEach((m: CompetitionMatch) => {
            m?.participants.forEach(mp => {
              JsonService.deriveFulImageURL(mp?.player, 'countryFlag');
              JsonService.deriveFulImageURL(mp?.player, 'nationalityFlag');
              JsonService.deriveFulImageURL(mp?.player, 'playerPhoto');
            });
            m?.competitionTeams.forEach(mt => {
              // JsonService.deriveFulImageURL(mt?.competitionTeam, 'teamLogo');
              if (mt?.competitionTeam?.teamLogo)
                JsonService.deriveFulImageURL(mt?.competitionTeam, 'teamLogo');
              else mt.competitionTeam.teamLogo = 'assets/icons/teamwork.png';
            });
            m?.competitionTeams.sort((ma, mb) => {
              return ma?.id - mb?.id;
            });
            JsonService.deriveFulImageURL(m, 'teamLogo');
            // if(m?.team)
            //   JsonService.deriveFulImageURL(m, 'teamLogo');
            // else m.teamLogo = 'assets/icons/teamwork.png';
          });
          matchPlayerLeaderboard?.teams?.sort((a, b) => {
            if (a?.competitionTeamId < b?.competitionTeamId) return -1;
            else if (a?.competitionTeamId > b?.competitionTeamId) return 1;
            else return 0;
          });
          matchPlayerLeaderboard?.matches?.forEach(match => {
            match?.competitionTeams?.sort((a, b) => {
              if (a?.competitionTeam?.id < b?.competitionTeam?.id) return -1;
              else if (a?.competitionTeam?.id < b?.competitionTeam?.id) return 1;
              else return 0;
            });
          });
          return matchPlayerLeaderboard;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public getCompTeamPlayers(
    compId: number,
    compTeamId?: number
  ): Observable<Array<CompetitionTeamPlayerData>> {
    let _params = {
      competitionTeamId: compTeamId,
    };
    let _url = global.ServerUrls.competition.getTeamPlayers;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      _params
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let compTeamPlayers: Array<CompetitionTeamPlayerData> = resp;
          compTeamPlayers.forEach((ctp: CompetitionTeamPlayerData) => {
            JsonService.deriveFulImageURL(ctp?.player, 'playerPhoto');
            JsonService.deriveFulImageURL(ctp?.player, 'countryFlag');
            JsonService.deriveFulImageURL(ctp?.player, 'nationalityFlag');
          });
          return compTeamPlayers;
        })
      )
      .pipe(catchError(this.http.handleError));
  }

  public getMatchProgressiveScores(
    compId: number,
    matchId: number
  ): Observable<Array<CompetitionMatchProgressiveScore>> {
    let _url = global.ServerUrls.competition.matchPlay.getProgressiveScoresByMatch;
    let reCompId = /:compId/gi;
    _url = _url.replace(reCompId, compId);
    let reMatchId = /:matchId/gi;
    _url = _url.replace(reMatchId, matchId);
    let request = new RemoteRequest(
      _url,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA
    );
    return this.http
      .execute(request)
      .pipe(
        map((resp: any) => {
          let matchProgressScores: Array<CompetitionMatchProgressiveScore> = resp;
          return matchProgressScores;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
}
